(function(){
	'use strict';

	const DEVICE_MOBILE = (function(){
		var ua = navigator.userAgent.toLowerCase();
		var list = ['mobile', 'android', 'iphone', 'ios', 'ipad'];
		for(let i=0; i<list.length; i++){
			if(ua.indexOf(list[i]) > -1){
				return true;
			}
		}
		return false;
	}());

	const Events = {
		data: {},
		types: {
			mousedown: ['mousedown', 'touchstart', 'pointerdown'],
			mousemove: ['mousemove', 'touchmove', 'pointermove'],
			mouseup: ['mouseup', 'touchend', 'pointerup'],
			mouseout: ['mouseout', 'pointerout']
		},
		findDelegateType: function(type){
			var types = this.findTypes(type);
			return types && types.name;
		},
		findTypes: function(type){
			if(!this.data.eventIndex){
				this.data.eventIndex = new Map();
				for(var key in this.types){
					var typeArray = this.types[key];
					typeArray.name = key;
					typeArray.forEach(type => {
						this.data.eventIndex.set(type, typeArray);
					});
				}
			}
			return this.data.eventIndex.get(type);
		},
		setEvents: function(types, callback){
			var parse = (oriType, func) => {
				var types = this.findTypes(oriType);
				if(types){
					types.forEach(type => {
						callback(type, oriType);
					});
				}else{
					callback(null, oriType);
				}
			}

			if(typeof(types) === 'string'){
				parse(types);
			}else{
				types.forEach(type => {
					parse(type);
				});
			}
		},
		addEventListener: function(el, types, listener, options){
			if(typeof(types) === 'string'){
				types = [types];
			}
			
			var removeListener = function(e){
				var pointEvent = e.type.startsWith('point');
				var types = Events.findTypes(e.type);
				types.forEach(type => {
					if(type === e.type) return;
					if(pointEvent && type.startsWith('touch')){
						return;
					}
					el.removeEventListener(type, removeListener);
					el.removeEventListener(type, listener);
				});
			};
			
			// TODO
			listener._rlo = listener._rlo || {};
			this.setEvents(types, (type, oriType) => {
				if(type){
					listener._rlo[oriType] = removeListener;

					el.addEventListener(type, removeListener, {once: true, passive: !type.startsWith('mouse')});
					if(
							type.startsWith('mouse')
							|| type.startsWith('point')
					){
						if(!options){
							options = {passive: true};
						}else if(typeof(options) === 'object'){
							options.passive = true;
						}
					}
				}
				el.addEventListener(type || oriType, listener, options);
			});
		},
		removeEventListener: function(el, types, listener){
			this.setEvents(types, (type, oriType) => {
				el.removeEventListener(type, listener);

				if(listener._rlo && listener._rlo[oriType]){
					el.removeEventListener(type,  listener._rlo[oriType]);
				}
			});
		}
	};

	// -- Polyfill S ------------------------------------------------
	(function() {
		if (typeof Object.assign === 'function') {
			return;
		}
		Object.assign = function(target) {
			'use strict';
			if (target === undefined || target === null) {
				throw new TypeError('Cannot convert undefined or null to object');
			}

			var output = Object(target);
			for (var index = 1; index < arguments.length; index++) {
				var source = arguments[index];
				if (source !== undefined && source !== null) {
					for ( var nextKey in source) {
						if (source.hasOwnProperty(nextKey)) {
							output[nextKey] = source[nextKey];
						}
					}
				}
			}
			return output;
		};
	})();

	Object.defineProperties(Object, {
		'extend' : {
			'configurable': true,
			'enumerable': false,
			'value': function extend(target, src){
				if(arguments.length > 2){
					var extObj = target;
					for(var i=1; i<arguments.length; i++){
						extObj = Object.extend(extObj, arguments[i]);
					}
					return extObj;
				}

				if(!src) return target;

				var witKeys = Object.keys(src);
				//var extObj = Object.keys(target).length ? Object.clone(target) : target;
				var extObj = target;

				witKeys.forEach(function(key){
					var value = src[key];
					var desc = Object.getOwnPropertyDescriptor(src, key);
					if(typeof(value) === 'object'){
						if(Array.isArray(value)){
							value = Object.extend([], value);
						}else if(value instanceof HTMLElement){
						}else{
							value = Object.clone(value);
						}
					}
					desc.value = value;
					
					Object.defineProperty(
						extObj,
						key,
						desc
					);
				});

				return extObj;
			},
			'writable': true
		},
		'clone': {
			'configurable': true,
			'enumerable': false,
			'value': function clone(obj){
				return Object.extend({}, obj);
			},
			'writable': true
		},
		'defineReadOnlyProperties': {
			'configurable': true,
			'enumerable': false,
			'value': function (obj, props){
				for(var k in props){
					if(!props.hasOwnProperty(k)) continue;
					var p = {};
					p[k] = {
						value: props[k],
						writable: false
					}
					Object.defineProperties(obj, p);
				}
			},
			'writable': false
		}
	});
	// -- Polyfill E ------------------------------------------------
	
	// private data
	var Data = {
		get: function(id){
			return this[id];
		},
		group: {}
	}

	var BaseMessage = {
		'ctxmenu.copy': '복사',
		'ctxmenu.paste': '붙여넣기',
		'ctxmenu.copy_paste': '바로 붙여넣기',
		'ctxmenu.remove': '삭제',
		'ctxmenu.arrange.front': '맨앞으로 이동',
		'ctxmenu.arrange.forward': '앞으로 이동',
		'ctxmenu.arrange.backward': '뒤로 이동',
		'ctxmenu.arrange.back': '맨뒤로 이동',
	};

	var GrmDefaultEventListen = function(grmCvs){
		grmCvs.elements.canvas
		// draw el transform
		._on('grm-transform', function(e){
			var el = e.target;
			if(el.matches('[data-g] *')){
				el = el.closest('[data-g]');
			}
			if(!el.matches('[data-g]')){
				return;
			}

			var type = e.data.type;
			var data = e.data.data;

			var baseRect = grmCvs.elements.baseEl.getBoundingClientRect();
			
			switch(type){
			case 'moveBy':
				var left = parseInt(el.style.left) + (data.x || 0),
					top = parseInt(el.style.top) + (data.y || 0);
				var width = parseInt(el.style.width),
					height = parseInt(el.style.height);

				var n = 20;
				if(left + width < n){
					left = n - width;
				}else if(left > baseRect.width){
					left = baseRect.width - n;
				}
				if(top + height < n){
					top = n - height;
				}else if(top > baseRect.height - n){
					top = baseRect.height - n;
				}

				el.style.left = left + 'px';
				el.style.top = top + 'px';

				if(data && data.publishEvent !== false){
					Data[grmCvs.id].GrmEvent.trigger(
						'transform',
						{
							did: el.getAttribute('data-did'),
							toolkit: el.getAttribute('data-toolkit'),
							transform: {
								left: el.style.left,
								top: el.style.top
							}
						}
					);
				}
				break;
			case 'arrange':
				grmCvs.arrangeDrawElement(el, data.arrangeValue);
				
				if(data && data.publishEvent !== false){
					Data[grmCvs.id].GrmEvent.trigger(
						'arrange',
						{
							did: el.getAttribute('data-did'),
							arrange: data.arrangeValue
						}
					);
				}
			}
		})
		;

		// 다른 grmcvs 에서 drag 함
		var dragCopyIcon;
		grmCvs.on('cvs-dragenter cvs-drag cvs-drop cvs-dragout', function(e){
			var data = e.data;

			switch(e.type){
			case 'cvs-dragenter':
				if(!dragCopyIcon){
					dragCopyIcon = document.createElement('div');
					dragCopyIcon.classList.add('grm-cvs-drag-copy-el');

					this.elements.baseEl.appendChild(dragCopyIcon)
				}
				dragCopyIcon.innerHTML = '+' + data.dragList.length;
				var rect = dragCopyIcon.getBoundingClientRect();
				// dragCopyIcon.w = rect.width / 2;
				// dragCopyIcon.h = rect.height / 2;
				dragCopyIcon.w = dragCopyIcon.h = 0;
			case 'cvs-drag':
				var point = Utils.getPoint(e.data.originalEvent, this.elements.baseEl);
				dragCopyIcon.style.left = (point.x - dragCopyIcon.w) + 'px';
				dragCopyIcon.style.top = (point.y - dragCopyIcon.h) + 'px';
				break;
			case 'cvs-drop':
				if(dragCopyIcon){
					dragCopyIcon.remove();
					dragCopyIcon = null;
				}
				
				var options = Data[this.id].options;
				var ratioZoom = options.zoom * options.ratio;
				
				var point = Utils.getPoint(e.data.originalEvent, this.elements.canvas);
				// var point = Utils.getOffsetPoint(e.data.originalEvent);
				point.x /= ratioZoom;
				point.y /= ratioZoom;
				console.log('@@@', point.x, point.y)

				var dragList = Array.prototype.map.call(data.dragList, function(el){
					return el.cloneNode(true);
				});

				if(dragList.length > 1){
					dragList.sort(function(a, b){
						return parseInt(a.style.left || '0') - parseInt(b.style.left || '0');
					});
				}
				var gapX = parseInt(dragList[0].style.left || '0');
				var gapY = parseInt(dragList[0].style.top || '0');

				dragList.forEach(function(el){
					var x = (parseInt(el.style.left || '0') - gapX) / ratioZoom + point.x;
					var y = (parseInt(el.style.top || '0') - gapY) / ratioZoom + point.y;
					el.style.left = x + 'px';
					el.style.top = y + 'px';
				});

				this.pasteDrawElements(dragList);
				break;
			case 'cvs-dragout':
				if(dragCopyIcon){
					dragCopyIcon.remove();
					dragCopyIcon = null;
				}
				break;
			}

			// console.log('## detect [%s] : %s -> %s', e.type, data.cvs.id, grmCvs.id, data.dragList.length);
		})
		;


		// data-g events
		function toolkit_trigger(e){
			var toolkitName = e.target.getAttribute('data-toolkit');
			var toolkit = grmCvs.getToolkit(toolkitName);
			if(toolkit){
				toolkit.trigger(e);
			}
		}
		grmCvs.elements.canvas
		._on('grm-g-selected', e => {
			e.target.removeAttribute('data-grm-drag-intersection');
			e.target.setAttribute('data-grm-selected', e.data && e.data.multiSelect ? 'multi' : '');

			var svg = e.target.querySelector('svg');
			if(svg && svg.firstElementChild){
			    let rect;
			    try{
                    rect = svg.firstElementChild.getClientRects()[0] || svg.firstElementChild.getBoundingClientRect()
                }catch(e){
				    rect = svg.firstElementChild.getBoundingClientRect();
                }

				let options = Data[grmCvs.id].options;
                console.log(options);

				e.target.style.width = rect.width / options.ratio;
				e.target.style.height = rect.height / options.ratio;
			}
			
			// rotate
			for(var i=0; i<4; i++){
				var dot = document.createElement('div');
				dot.setAttribute('data-type', 'rotate-dot');
				dot.setAttribute('data-rotate-type', i);
				
				e.target.appendChild(dot);
			}
			// resize
			for(var i=0; i<8; i++){
				var dot = document.createElement('div');
				dot.setAttribute('data-type', 'resize-dot');
				dot.setAttribute('data-resize-type', i);
				
				e.target.appendChild(dot);
			}

			toolkit_trigger(e);
		})
		._on('grm-g-unselected', e => {
			e.target.removeAttribute('data-grm-selected');
			e.target.querySelectorAll('[data-type="rotate-dot"], [data-type="resize-dot"]')
			.forEach(dot => {
				dot.remove();
			});

			toolkit_trigger(e);
		})
		;
	}
	
	// constructor
	var GooroomeeCanvas = function(target, options){
		if(!target || target instanceof HTMLElement === false){
			throw 'target error : ' + target;
		}

		var THIS = this;

		// set id
		var groupId = (options && options.groupId) || 'gooroomee';
		var id = Utils.createId();
		Object.defineReadOnlyProperties(this, {
			'groupId': groupId,
			'id': id,
			'target': target
		});

		// set options
		var targetRect = (function(){
			var w = target.ownerDocument.defaultView;
			var style = w.getComputedStyle(target);
			var data = {};
			['width', 'height'].forEach(key => {
				let v = style.getPropertyValue(key);
				if(v && v.endsWith('%')){
					v = target.getBoundingClientRect()[key];
				}else{
					v = parseFloat(v);
				}
				if(v){
					data[key] = v;
				}
			})
			return data;
		}())
		options = Object.extend({
			bgColor: '#ffffff',
			message: BaseMessage,
			autoRatio: true,
			ratio: 1,
			zoom: 1,
			useWheel: false,
			useToolkitDefaultMouseButton: true,
			useCopyAndPasteOption: true,
			excludeContextMenu: null
		}, options || {}, {
			canvasWidth: options.canvasWidth ? parseFloat(options.canvasWidth) : targetRect.width,
			canvasHeight: options.canvasHeight ? parseFloat(options.canvasHeight) : targetRect.height,
		});
		Object.defineReadOnlyProperties(options, {
			targetRect: targetRect
		});
//		try{
//			// freeze options
//			// Object.freeze(options);
//		}catch(e){}

		// create css
		GrmCvsStyle.generate();
		
		// -- create base element S ------------------
		{
			var elements = {
				window: target.ownerDocument.defaultView
			};
			Object.defineReadOnlyProperties(this, {
				'elements': elements
			});

			elements.boxEl = document.createElement('div');
			elements.boxEl.setAttribute('data-grm-cvs', 'box');
			elements.boxEl.setAttribute('tabindex', '999');
			target.appendChild( elements.boxEl );
			elements.boxEl._on('focus blur', function(e){
				if(e.type === 'focus'){
					target.setAttribute('data-focused', '');
				}else{
					target.removeAttribute('data-focused');
				}
				Data[id].GrmEvent.trigger(e.type);
			});

			if(options.autoResizeDetection === true){
				addResizeListener(elements.boxEl, e => {
					clearTimeout(elements.boxEl._grm_resize_timer);
					elements.boxEl._grm_resize_timer = setTimeout(() => {
						this.redraw();
					}, 10);
				});
			}

			elements.wrapper = document.createElement('div');
			elements.wrapper.setAttribute('data-grm-cvs', 'wrapper');
			elements.boxEl.appendChild( elements.wrapper );
			
			elements.baseEl = document.createElement('div');
			elements.baseEl.setAttribute('data-grm-cvs', 'base');
			elements.wrapper.appendChild( elements.baseEl );
			//elements.baseEl.onselectstart = elements.baseEl.ondragstart =
			elements.baseEl._on('selectstart dragstart', function(e){
				e.preventDefault();
				return false;
			});
			Object.assign(elements.baseEl.style, {
				// 'width': options.canvasWidth || '100%',
				// 'height': options.canvasHeight || '100%',
				// 'background-color': options.bgColor,
			});
			
			elements.canvas = document.createElement('div');
			elements.canvas.setAttribute('data-grm-cvs', 'canvas');
			// elements.canvas.setAttribute('draggable', 'true');
			elements.baseEl.appendChild( elements.canvas );
			Object.assign(elements.canvas.style, {
				// 'width': options.canvasWidth || '100%',
				// 'height': options.canvasHeight || '100%',
				// 'width': options.canvasWidth + 'px',
				// 'height': options.canvasHeight + 'px',
				'width': options.targetRect.width + 'px',
				'height': options.targetRect.height + 'px',
				'background-color': options.bgColor,
				'overflow': 'hidden'
			});

			elements.drawingCanvas = SvgUtils.createElement('svg');
			elements.drawingCanvas.setAttribute('data-grm-cvs', 'drawing-canvas');
			elements.baseEl.appendChild( elements.drawingCanvas );

			var eventTarget = elements.canvas; // elements.baseEl;

			function eventListener(e){
				//var grmCvs = this._grmCvs;
				var toolkit = THIS.getToolkit();
				if(!toolkit){
					return;
				}

				switch(e.type){
				case 'mousedown':
				case 'touchstart':
				case 'pointerdown':
					toolkit.mousedown(e);

					eventTarget._off('mousemove touchmove pointermove', eventListener);
					// elements.window.addEventListener('mousemove', eventListener, false);
					// elements.window.addEventListener('touchmove', eventListener, {passive: true});
					// elements.window.addEventListener('pointermove', eventListener, {passive: true});
					// ['mouseup', 'touchend', 'pointerup'].forEach(function(type){
					// 	elements.window.addEventListener(type, eventListener, {once: true});
					// })
					Events.addEventListener(elements.window, 'mousemove', eventListener);
					Events.addEventListener(elements.window, 'mouseup', eventListener, {once: true});
					break;
				case 'mousemove':
				case 'touchmove':
				case 'pointermove':
					toolkit.mousemove(e);
					break;
				case 'mouseup':
				case 'touchend':
				case 'pointerup':
					toolkit.mouseup(e);

					Events.removeEventListener(elements.window, 'mouseup', eventListener);
					Events.addEventListener(eventTarget, 'mousemove', eventListener);
					break;
				case 'wheel':
					toolkit.wheel(e);
					break;
				case 'mouseout':
					toolkit.mouseout(e);
					break;
				case 'dblclick':
					if(toolkit.dblclick)
						toolkit.dblclick(e);
					break;
				}
			}

			// TODO pinch
			if(DEVICE_MOBILE){
				if(window.PinchZoom){
					let pz = new (PinchZoom.default || PinchZoom)(elements.canvas);
					/*
					pz_zoomstart  Started to zoom
					pz_zoomend    Stopped zooming
					pz_zoomupdate Zoom factor updated
					pz_dragstart  Started to drag the element
					pz_dragend    Stopped to drag the element
					pz_dragupdate Drag position updated
					pz_doubletap  Resetting the zoom with double-tap
					*/
					elements.canvas
					._on('pz_zoomstart', e => {
						console.log('@@@ ', e.type, e);
					})
					._on('pz_zoomend', e => {
						console.log('@@@ ', e.type, e);
					})
					._on('pz_zoomupdate', e => {
						console.log('@@@ ', e.type, e);
					})
					._on('pz_zoomupdate', e => {
						console.log('@@@ ', e.type, e);
					})
					._on('pz_doubletap', e => {
						console.log('@@@ ', e.type, e);
					})
					;
				}
			}

			// [
			// 	'mousedown',
			// 	'mousemove',
			// 	'mouseout',
			// 	// 'mouseup',
			// ].forEach(function(type){
			// 	eventTarget.addEventListener(type, eventListener, false);
			// });
			// [
			// 	'touchstart',
			// 	'touchmove',
			// ].forEach(function(type){
			// 	eventTarget.addEventListener(type, eventListener, {
			// 		passive: true
			// 	});
			// });
			Events.addEventListener(eventTarget, [
				'mousedown',
				'mousemove',
				'mouseout',
				'dblclick',
			], eventListener);
			if(options.useWheel !== false){
				eventTarget._on('wheel', eventListener, {
					passive: true
				});
			}

			elements.canvas.addEventListener('contextmenu', function(e){
				if(options.useContextMenu === false){
					return;
				}

				if(!THIS.getToolkit()) return;
				if(THIS.getToolkit().listeners.contextmenu){
					var rt = THIS.getToolkit().listeners.contextmenu.call(THIS.getToolkit(), e);
					if(rt === false){
					}else{
						e.preventDefault();
					}
					return false;
				}
			});

			if(DEVICE_MOBILE) {
				elements.canvas.addEventListener('dblclick', function (e) {
					if (options.useContextMenu === false) {
						return;
					}

					if (!THIS.getToolkit()) return;
					if (THIS.getToolkit().listeners.contextmenu) {
						var rt = THIS.getToolkit().listeners.contextmenu.call(THIS.getToolkit(), e);
						if (rt === false) {
						} else {
							e.preventDefault();
						}
						return false;
					}
				});
			}

			elements.window._on('resize orientationchange', (function(e){
				setTimeout(this.redraw.bind(this), 50);
				// this.redraw();
			}).bind(this));
		}
		// -- create base element E ------------------

		// set properties getter, setter
		{
			var Properties = new Map();
			var getter = function(key){
				return Properties.get(key);
			}
			var setter = function(key, callback){
				return function(value){
					var rt = null;
					try{

						rt = callback.call(this, value, Properties, key);
					}finally{
						if(rt === false){
							return;
						}else if(rt !== undefined){
							Properties.set(key, rt);
						}else{
							Properties.set(key, value);
						}
					}
				};
			}

			for(var key in GooroomeeCanvasProperties){
				(function(target){
					Object.defineProperty(target, key, {
						get: function(){
							return Properties.get(key);
						},
						set: setter(key, GooroomeeCanvasProperties[key])
					});
				}(this, key));
			}
		}

		// set private data
		var groupData = Data.group[groupId] = Data.group[groupId] || {};
		groupData.cvsList = groupData.cvsList || [];
		groupData.cvsList.push(this);

		Data[id] = {
			id: id,
			grmCvs: this,
			options: options,
			GrmEvent: new GrmEvent(this),
			toolkits: Toolkits.createToolkits(this)
		};

		if(options.autoRatio){
			this.zoomFit();
		}

		// this.toolkit = options.toolkit || 'Pencil';
		this.changeToolkit(options.toolkit || 'Pencil');

		this.setHotKeyEnable(true);

		// set events
		Data[id].GrmEvent.setOnOffEvents(this);
		GrmDefaultEventListen(this);

		// undo, redo
		Data[id].Job = {
			id: id,
			grmCvs: this,
			jobQ: [],
			redoQ: [],
			addJob: function(job, data, noClearRedo){
				if(noClearRedo !== false){
					this.redoQ = [];
				}
				this.jobQ.push({
					job: job,
					data: data
				});
				if(this.jobQ.length > 30){
					this.jobQ.shift();
				}
			},
			undo: function(){
				var data = Data[this.id];

				var job = this.jobQ.pop();
				if(!job) return;
				this.redoQ.push(job);
				
				switch(job.job){
				case 'add':
					if(job.data.did && !job.data.el){
						job.data.el = this.grmCvs.findDrawElement(job.data.did);
					}else if(!job.data.did && job.data.el){
						var did = job.data.el.getAttribute('data-did');
						job.data.did = did;
					}
					data.grmCvs.removeDrawElements(job.data.el || job.data.did);
					break;
				case 'remove':
					data.grmCvs.addDrawElements(job.data.el);
					break;
				case 'transform':
					var els = this.grmCvs.findDrawElements(job.data.did);
					for(var i=0,len=els.length; i<len; i++){
						var el = els[i];
						if(!el) continue;
						
						var transform = job.data.transform[i].before;
						['left', 'top', 'width', 'height'].forEach(function(s){
							el.style[s] = transform[s];
						});
						var svgEl = el.querySelector('[data-draw]')
						var scale = SvgUtils.getTransform(el, 'scale'),
							translate = SvgUtils.getTransform(el, 'translate');
						scale.setScale(transform.scaleX, transform.scaleY);
						// translate.setTranslate(transform.translateX, transform.translateY);
					}
					break;
				}
			},
			redo: function(){
				var data = Data[this.id];

				var job = this.redoQ.pop();
				if(!job) return;
				this.addJob(job.job, job.data, false);

				switch(job.job){
				case 'add':
					data.grmCvs.addDrawElements(job.data.el);
					break;
				case 'remove':
					data.grmCvs.removeDrawElements(job.data.el);
					break;
				case 'transform':
					var els = this.grmCvs.findElements(job.data.did);
					for(var i=0,len=els.length; i<len; i++){
						var el = els[i];
						if(!el) continue;
						
						var transform = job.data.transform[i].after;
						['left', 'top', 'width', 'height'].forEach(function(s){
							el.style[s] = transform[s];
						});
						var scale = SvgUtils.getTransform(el, 'scale'),
							translate = SvgUtils.getTransform(el, 'translate');
						scale.setScale(transform.scaleX, transform.scaleY);
						// translate.setTranslate(transform.translateX, transform.translateY);
					}
					break;
				}
			}
		};
	}

	var GooroomeeCanvasProperties = {
		// toolkit: function(_toolkit, prop, key){
		// 	var toolkit = null;
		// 	if(typeof(_toolkit) === 'string'){
		// 		toolkit = Data[this.id].toolkits[_toolkit.toLowerCase()];
		// 	}else{
		// 		toolkit = Data[this.id].toolkits[_toolkit.name];
		// 	}
		// 	if(!toolkit){
		// 		// TODO
		// 		console.warn('toolkit is undefined :', _toolkit);
		// 		return false;
		// 	}

		// 	for(var k in toolkit.style.base){
		// 		this.elements.baseEl.style[k] = toolkit.style.base[k];
		// 	}
		// 	this.elements.baseEl.setAttribute('data-toolkit-name', toolkit.name);

		// 	var old = this.toolkit;
		// 	if(old){
		// 		old.afterChange();
		// 	}
		// 	toolkit.preChange();

		// 	prop.set(key, toolkit);
		// 	Data[this.id].GrmEvent.trigger('change-toolkit', {
		// 		beforeToolkit: old,
		// 		toolkit: toolkit
		// 	});

		// 	return toolkit;
		// }
	}
	
	// GooroomeeCanvas : lify cycle
	Object.assign(GooroomeeCanvas.prototype, {
		destroy: function(){
			try{
				this.setHotKeyEnable(false);
			}finally{
				// remove data
				delete Data[this.id];
			}

		},
	});

	// GooroomeeCanvas : draw element
	Object.assign(GooroomeeCanvas.prototype, {
		createDrawId: function(){
			return Utils.generateUID();
		},
		createDrawElement: function(){
			var g = document.createElement('div');
			g.setAttribute('data-g', '');
			g.setAttribute('data-did', this.createDrawId());
			// g.setAttribute('draggable', 'true');

			g.style.left = g.style.top = '0px';
			return g;
		},
		clear: function(options){
			var els = this.elements.baseEl.querySelectorAll('[data-g]');
			this.removeDrawElements(els, {publishEvent: false});
			
			if(!options || options.publishEvent !== false){
				var data = Data[this.id];
				data.GrmEvent.trigger('clear');
			}
			return this;
		},
		isDrawElement: function(el){
			if(el && el instanceof HTMLElement === false){
				return false;
			}
			return el.hasAttribute('data-g');
		},
		isDragOverCanvas: function(point){
			var rect = this.elements.canvas.getBoundingClientRect();
			return (
				point.x > rect.left
				&& point.x < rect.right
				&& point.y > rect.top
				&& point.y < rect.bottom
			);
		},
		getAllElements: function(){
			return this.elements.baseEl.querySelectorAll('[data-g]');
		},
		findDrawElement: function(did){
			if(!did){
				return null;
			}
			if(this.isDrawElement(did)){
				return did;
			}
			return this.elements.baseEl.querySelector('[data-did="'+did+'"]');
		},
		findDrawElements: function(didList){
			if(!didList){
				return null;
			}

			let selector = '';
			didList.forEach(function(did, idx){
				if(idx > 0){
					selector += ', '
				}
				selector += '[data-did="'+did+'"]';
			});

			// return this.elements.baseEl.querySelectorAll(selector);
			return this.findDrawElementsBySelector(selector);
		},
		findDrawElementsBySelector: function(selector){
			if(!selector){
				return null;
			}

			return this.elements.baseEl.querySelectorAll(selector);
		},
		addDrawElements: function(el, options){
			if(Array.isArray(el) || el instanceof NodeList){
				el.forEach((function(el){
					this.addDrawElements(el);
				}).bind(this));

				if(options && options.addJob){
					var jobData = options.jobData || {};
					jobData.el = el;
					Data[this.grmCvs.id].Job.addJob('add', jobData);
				}
				return el;
			}

			let did = el.getAttribute('data-did');
			// if(!did || this.findDrawElement(did)){
			if(!did){
				did = this.createDrawId();
				el.setAttribute('data-did', did);
			}else{
				let existed = this.findDrawElement(did);
				if(existed && existed !== el){
					// existed.attributes.length
					Object.assign(existed.dataset, el.dataset);
					Object.assign(existed.style, el.style);
					existed.innerHTML = el.innerHTML;

					el = existed;
				}
			}
			if(this.elements.canvas.contains(el) === false){
				this.elements.canvas.appendChild(el);
			}

			if(options && options.addJob){
				let jobData = options.jobData || {};
				jobData.did = el.getAttribute('data-did');
				jobData.el = el;
				Data[this.id].Job.addJob('add', jobData);
			}
			
			try{
				// TODO
				if(!options || options.publishEvent !== false){
					let data = Data[this.id];
					// var svg = el.querySelector('svg');
					data.GrmEvent.trigger(
						'addElement',
						Object.assign(
							{
								did: did,
								styleText: el.style.cssText,
								// svg: svg && svg.outerHTML,
							},
							el.dataset
						)
					);
				}
			}catch(e){
				console.error('publish event error', e);
			}
		},
		removeDrawElements: function(el, options){
			if(Array.isArray(el) || el instanceof NodeList){
				var opt = Object.assign({}, options, {addJob: false})
				var did = [];
				el.forEach((function(e){
					did.push(typeof e === 'string' ? e : e.getAttribute('data-did'));
					this.removeDrawElements(e, opt);
				}).bind(this));

				if(options && options.addJob){
					var jobData = options.jobData || {};
					jobData.did = did;
					jobData.el = el;
					Data[this.id].Job.addJob('remove', jobData);
				}
				return;
			}else if(typeof el === 'string'){
				el = this.findDrawElement(el);
			}

			if(!el) return;

			var data = Data[this.id];
			var toolkit = el.getAttribute('data-toolkit');
			toolkit = data.toolkits[toolkit];
			if(!toolkit || !toolkit.removeElement){
				el.remove();
			}else{
				toolkit.removeElement(el);
			}

			var did = el.getAttribute('data-did');
			if(!did) return;

			if(!options || options.publishEvent !== false){
				data.GrmEvent.trigger('removeElement', {
					did: [did],
					element: [el]
				});
			}

			if(options && options.addJob){
				var jobData = options.jobData || {};
				jobData.did = did;
				jobData.el = el;
				Data[this.id].Job.addJob('remove', jobData);
			}
		},
		transformDrawElement: function(did, transform){
			var el = this.findDrawElement(did);
			if(!el){
				return false;
			}
			['left', 'top', 'width', 'height', 'transform'].forEach(function(s){
				if(!transform[s]) return;
				el.style[s] = transform[s];
			});

			if(transform.scaleX && transform.scaleY){
				var draw = el.querySelector('[data-draw]');
				if(draw){
					var scale = SvgUtils.getTransform(draw, 'scale');
					scale.setScale(transform.scaleX, transform.scaleY);
				}
			}
			return true;
		},
		arrangeDrawElement: function(did, arrange){
			var el = this.findDrawElement(did);
			if(!el){
				return false;
			}
			switch(arrange){
			case 'front':
				this.elements.canvas.appendChild(el);
				break;
			case 'back':
				this.elements.canvas.prepend(el);
				break;
			case 'forward':
				// TODO 여러개 이동 미완
				var next;
				try{
					next = el.nextElementSibling.nextElementSibling;
				}catch(e){}
				if(next){
					this.elements.canvas.insertBefore(el, next);
				}else{
					this.elements.canvas.appendChild(el);
				}
				break;
			case 'backward':
				var prev = el.previousElementSibling;
				if(prev){
					this.elements.canvas.insertBefore(el, prev);
				}else{
					this.elements.canvas.prepend(el);
				}
				break;
			}
		},
		minimizeDrawElement: function(el, minimize, publishEvent){
			if(typeof(el) === 'string'){
				el = this.findDrawElement(el);
			}
			if(!el){
				return false;
			}
			var toolkitName = el.getAttribute('data-toolkit');
			if(!toolkitName){
				return;
			}
			var toolkit = this.getToolkit(toolkitName);
			if(!toolkit){
				return;
			}

			if(toolkit.minimize){
				toolkit.minimize(el, minimize, publishEvent === true);
			}
		},
		copyDrawElements: function(els){
			var THIS = this;
			var options = Data[this.id].options;
			if(!options.useCopyAndPasteOption){
				return;
			}

			var copyElements = [];
			if(Array.isArray(els) || els instanceof NodeList){
				els.forEach(function(el){
					if( THIS.isDrawElement(el) ){
						copyElements.push(el);
					}
				});
			}else if( THIS.isDrawElement(els) ){
				copyElements.push(els);
			}else{
				// TODO
				throw 'not supported element(s) : ' + els;
			}

			if(copyElements.length === 0){
				copyElements = null;
			}
			Data.group[this.groupId].copyElements = copyElements;

			console.log('# copy elements :', copyElements.length);
		},
		pasteDrawElements: function(els, selected){
			var options = Data[this.id].options;
			if(!options.useCopyAndPasteOption){
				return;
			}

			els = els || Data.group[this.groupId].copyElements;
			if(!els){
				return;
			}

			var THIS = this;
			var copyElements = [];
			if(Array.isArray(els) || els instanceof NodeList){
				els.forEach(function(el){
					if( THIS.isDrawElement(el) ){
						copyElements.push( chk(el) );
					}
				});
			}else if( THIS.isDrawElement(els) ){
				copyElements.push( chk(els) );
			}else{
				// TODO
				throw 'not supported element(s) : ' + els;
			}

			var THIS = this;
			function chk(el){
				var clone = el.cloneNode(true);
				var copyDid = el.getAttribute('data-did');

				if(!copyDid){
					return clone;
				}

				var did = THIS.createDrawId();
				clone.setAttribute('data-did', did);
				clone.setAttribute('data-copy-did', copyDid);
				var ex = THIS.findDrawElement(copyDid);
				if(ex){
					_pos(ex, clone);
				}

				var cpList = THIS.elements.baseEl.querySelectorAll('[data-copy-did="'+copyDid+'"]');
				cpList.forEach(function(ex){
					_pos(ex, clone);
				});

				function _pos(ex, clone){
					var left = parseInt( ex.style.left ),
						top = parseInt( ex.style.top );
					var base = 15;
					if(!isNaN(left) && Math.abs(parseInt( clone.style.left ) - left) < base ){
						clone.style.left = (left + base) + 'px';
					}
					if(!isNaN(top) && Math.abs(parseInt( clone.style.top ) - top) < base ){
						clone.style.top = (top + base) + 'px';
					}
				}

				return clone;
			}

			copyElements.forEach(function(el){
				switch(el.getAttribute('data-toolkit')){
				case 'link':
					THIS.addLink(Object.assign({
						cssText: el.style.cssText
					}, el.dataset));
					break;
				default:
					THIS.addDrawElements(el);
					break;
				}
			});

			if(selected !== false){
				var toolkit = this.changeToolkit('select', {
					after: false,
					pre: false
				});
				toolkit.clearSelectedElements();
				toolkit.selectElements(copyElements, false);
			}

			console.log('# paste elements :', copyElements.length);
		},
	});	

	// GooroomeeCanvas : toolkit
	Object.assign(GooroomeeCanvas.prototype, {
		setHotKeyEnable: function(enable){
			enable = enable !== false;
			var data = Data[this.id];
			if(data.hotKeyEnabled === enable){
				return;
			}

			data.hotKeyEnabled = enable;

			// var body = this.elements.baseEl.ownerDocument.body;
			var body = this.elements.boxEl;
			if(enable){
				data.docKeyUpListener = (function(grmCvs){
					return function(e){
						var toolkit = grmCvs.getToolkit();
						if(!toolkit){
							return;
						}
						if(!toolkit.listeners || !toolkit.listeners.hotkeyUp){
							return;
						}
						// console.log('# grmCvs hotkeyUp :', e.key);
						return toolkit.listeners.hotkeyUp.call(toolkit, e);
					};
				}(this));
				data.docKeyDownListener = (function(grmCvs){
					return function(e){
						var toolkit = grmCvs.getToolkit();
						if(!toolkit){
							return;
						}
						if(!toolkit.listeners || !toolkit.listeners.hotkeyDown){
							return;
						}
						// console.log('# grmCvs hotkeyDown :', e.key);
						return toolkit.listeners.hotkeyDown.call(toolkit, e);
					};
				}(this));

				this.elements.boxEl._on('keydown', data.docKeyDownListener);
				this.elements.boxEl._on('keyup', data.docKeyUpListener);
			}else{
				this.elements.boxEl._off('keydown', data.docKeyDownListener);
				this.elements.boxEl._off('keyup', data.docKeyUpListener);
			}
		},
		getToolkit: function(name){
			if(name){
				return Data[this.id].toolkits[name];
			}else{
				return Data[this.id].currToolkit;
			}
		},
		changeToolkit: function(_toolkit, options){
			var toolkit = null;
			if(typeof(_toolkit) === 'string'){
				toolkit = Data[this.id].toolkits[_toolkit.toLowerCase()];
			}else{
				toolkit = Data[this.id].toolkits[_toolkit.name];
			}
			if(!toolkit){
				// TODO
				console.warn('toolkit is undefined :', _toolkit);
				return false;
			}

			var old = this.getToolkit();
			if(old){
				if(old === toolkit){
					return toolkit;
				}
				old.afterChange(options);
			}
			
			for(var k in toolkit.style.base){
				this.elements.baseEl.style[k] = toolkit.style.base[k];
			}
			this.elements.baseEl.setAttribute('data-toolkit-name', toolkit.name);

			Data[this.id].currToolkit = toolkit;
			toolkit.preChange(options);

			Data[this.id].GrmEvent.trigger('change-toolkit', {
				prevToolkit: old,
				toolkit: toolkit
			});

			return toolkit;
		},
		changeTransientToolkit: function(toolkit, options){
			var oldToolkit = this.getToolkit();
			if(oldToolkit.name === toolkit){
				return;
			}
			// grmCvs.toolkit = toolkit;
			toolkit = this.changeToolkit(toolkit, {
				once: true
			});
			Events.addEventListener(this.elements.window, (options && options.cancelEvent) || 'mouseup', e=>{
				if(toolkit.mouseup){
					toolkit.mouseup.call(toolkit, e);
				}
				this.changeToolkit( oldToolkit );
			}, {once: true});

			if(!options || !options.event) return;

			var event = options.event;

			var delegateType = Events.findDelegateType(event.type);
			if(toolkit[delegateType]){
				toolkit[delegateType].call(toolkit, event);
			}
		},
		changeToolkitPathStyle: function(type, value, toolkitName){
			if(typeof type === 'object'){
				toolkitName = value;
			}

			var data = Data[this.id];
			var toolkit = data.toolkits[toolkitName] || this.getToolkit();
			if(!toolkit.style || !toolkit.style.path) return;

			function change(grmCvs, type, value){
				toolkit.style.path[type] = value;
				if(toolkit.reloadStyle){
					toolkit.reloadStyle();
				}
				data.GrmEvent.trigger('change-toolkit-path-style', {
					toolkit: toolkit,
					type: type,
					value: value
				});
			}

			if(typeof type === 'object'){
				for(var key in type){
					change(this, key, type[key]);
				}
			}else{
				change(this, type, value);
			}

		},
	});

	// GooroomeeCanvas : pointer
	Object.assign(GooroomeeCanvas.prototype, {
		addPointer: function(pointer){
			var pointers = Data[this.id].pointers = Data[this.id].pointers || new Map();
			var p = pointers.get(pointer.id);
			if(p){
				Object.assign(p, pointer);
			}else{
				pointers.set(pointer.id, pointer);
			}
			if(!pointer.color){
				pointer.color = 'red';
			}
			this.drawPointers();
		},
		removePointer: function(pointer){
			var id = pointer;
			if(typeof pointer === 'object'){
				id = pointer.id;
			}

			this.elements.baseEl.querySelectorAll('[data-grm-laserpointer="'+id+'"]').forEach(el => {
				el.remove();
			});

			var pointers = Data[this.id].pointers = Data[this.id].pointers || new Map();
			pointers.delete(id);
			this.drawPointers();
		},
		drawPointers: function(){
			var cvsData = Data[this.id];
			var baseRect = this.elements.baseEl.getBoundingClientRect();
			var centerPoint = this.getCenterPoint();
			var matrix = this.canvasMatrix();
			var ratio = matrix[0] * cvsData.options.ratio;
			var moveX = matrix[4];
			var moveY = matrix[5];
			
			var pointers = cvsData.pointers = cvsData.pointers || new Map();

			// var baseEl = this.elements.baseEl;
			var baseEl = this.elements.canvas;
			var toolkit = Data[this.id].toolkits['laserpointer'];
			var pointRd = 25;
			pointers.forEach((info, id) => {
				try{
					var pointer = baseEl.querySelector('[data-grm-laserpointer="'+id+'"]');
					if(!pointer){
						pointer = toolkit.createPointerElement(baseEl);
						pointer.setAttribute('data-grm-laserpointer', id);
					}
					pointer.stop.setAttribute('stop-color', info.color);
					pointer.style.left = (info.x - pointRd) + 'px';
					pointer.style.top = (info.y - pointRd) + 'px';
					pointer.style.transform = `scale(${1+ratio}, ${1+ratio})`;
					//console.log('@@@ 3:', info.x, info.y);
					// pointer.style.left = ((info.x + moveX) / ratio) + 'px';
					// pointer.style.top = ((info.y + moveY) / ratio) + 'px';
					
					// {
					// 	var x = info.x / cvsData.options.canvasWidth * baseRect.width;
					// 	var y = info.y / cvsData.options.canvasHeight * baseRect.height;
						
					// 	x += (matrix[4] - centerPoint.x) / cvsData.options.ratio;
					// 	y += (matrix[5] - centerPoint.y) / cvsData.options.ratio;

					// 	console.log('@@@ 3:', x, y);
						
					// 	pointer.style.left = x + 'px';
					// 	pointer.style.top = y + 'px';
					// }

					if(info.name){
						var pName = pointer.querySelector('[data-pointer-name]');
						if(!pName){
							pName = document.createElement('div');
							pName.setAttribute('data-pointer-name', '');
							pName.style.backgroundColor = info.color;
							pointer.appendChild(pName);
						}
						pName.innerText = info.name;
					}else{

					}
				}catch(e){
					console.error('draw pointer error :', info, e);
				}
			});
			
		},
	});

	// GooroomeeCanvas : image
	Object.assign(GooroomeeCanvas.prototype, {
		addImage: function(el, options){
			return new Promise((resolve, reject) => {
				let create = (img) => {
					let oriWidth = img.width, oriHeight = img.height;
					let width = img.width, height = img.height;

					let image = SvgUtils.createElement('image');
					image.setAttribute('data-draw', '');
					
					SvgUtils.setAttributeNS(image, 'xlink', 'href', img.src);
					image.setAttributeNS(null, 'width', width + 'px');
					image.setAttributeNS(null, 'height', height + 'px');

					// image.addEventListener('load', e =>{
						// create svg
						let svg = SvgUtils.createElement('svg');
						{
							let sx = 1, sy = 1;

							if(options && options.adjustSizeRatio){
								let ajRatio = options.adjustSizeRatio;

								let grmOpts = Data[this.id].options;
								let pW = grmOpts.canvasWidth * ajRatio;
								let pH = grmOpts.canvasHeight * ajRatio;

								let ratio = Math.max(pW / width, pH / height);
								sx = sy = ratio;
								width *= ratio;
								height *= ratio;
							}

							let scale = svg.createSVGTransform();
							scale.setScale(sx, sy);
							image.transform.baseVal.appendItem(scale);
							
							// let translate = svg.createSVGTransform();
							// translate.setTranslate(-left, -top);
							// image.transform.baseVal.appendItem(translate);
							
							svg.appendChild(image);
						}
						
						// create g
						{
							let g = this.createDrawElement();
							g.setAttribute('data-toolkit', 'image');
							g.appendChild(svg);
							this.addDrawElements(g, {publishEvent: false});
							// let cp = this.getCenterPoint();

							let left = 0, top = 0;
							if(!options || !options.position){
								let grmOpts = Data[this.id].options;
								left = (grmOpts.canvasWidth / 2) - (width / 2);
								top = (grmOpts.canvasHeight / 2) - (height / 2);
							}

							Object.assign(g.style, {
								'left': left + 'px',
								'top': top + 'px',
								'width': width + 'px',
								'height': height + 'px',
							});

							this.addDrawElements(g, {publishEvent: true});

							resolve({
								el: g,
								oriWidth: oriWidth,
								oriHeight: oriHeight
							});
						}
					// }, {once: true});

				}

				let type = typeof(el);
				switch(type){
				case 'string':
					let img = new Image();
					img.src = el;
					img.addEventListener('load', (e) => {
						create(e.target);
					}, {once: true});
					img.addEventListener('error', reject, {once: true});
					break;
				case 'obj':
					if(el.nodeName && el.nodeName.toLowerCase() === 'img'){
						create(el);
					}else{
						// TODO
						throw 'not supported object';
					}
					break;
				}
			});
		},
		changeBackgroundImage: function(image){
			if(typeof image === 'string'){
				var callback = this.changeBackgroundImage.bind(this);
				return new Promise(function(resolve, reject){
					var img = document.createElement('img');
					img.src = image;
					img.onload = function(){
						callback(img).then(function(result){
							resolve(result);
						});
					}
					img.onerror = function(e){
						reject(e);
					}
				});
			}else if(image instanceof HTMLImageElement){
				// TODO
				Object.assign(this.elements.canvas.style, {
					'background-image': 'url('+image.src+')',
					'background-repeat': 'no-repeat',
					'background-size': image.width > image.height ? '100% auto' : 'auto 100%',
					'background-position': 'center center',
				});

				var result = {
					width: image.width,
					height: image.height
				};

				Data[this.id].GrmEvent.trigger('changeBackgroundImage', result);
				return Promise.resolve(result);
			}
		}
	});

	// GooroomeeCanvas : matrix
	Object.assign(GooroomeeCanvas.prototype, {
		changeMediaElementState: function(data){
			var g = this.findDrawElement(data.did);
			if(!g) return false;

			if(!g.player){
				console.warn('player is undefined :', data);
				return;
			}

			g._trigger('changestate', data)
			// switch(g.getAttribute('data-link-service-type')){
			// case 'youtube':
			// 	switch(data.state){
			// 	case 'play':
			// 	case 'playing':
			// 		g.player.playVideo();
			// 		break;
			// 	case 'pause':
			// 	case 'paused':
			// 		g.player.pauseVideo();
			// 	}
			// 	if(data.currentTime !== undefined){
			// 		g.player.seekTo( data.currentTime );
			// 	}
			// 	break;
			// }
		},
		isMoveEnable: function(){
			// var matrix = this.canvasMatrix();
			// var ratio = matrix.ratio * matrix.zoom;
			// if(matrix.oriWidth * ratio > matrix.canvasWidth){
			// 	return true;
			// }else if(matrix.oriHeight * ratio > matrix.canvasHeight){
			// 	return true;
			// }
			// return false;

			var options = Data[this.id].options;
			if(options.zoom <= 1){
				return false;
			}

			var baseRect = this.elements.baseEl.getBoundingClientRect();
			var rect = this.elements.canvas.getBoundingClientRect();

			console.log('@@@ 1 :', baseRect.left, rect.left, baseRect.left + rect.left);
			console.log('@@@ 2 :', baseRect.top, rect.top, baseRect.top + rect.top);
			if(
				baseRect.top + rect.top > 0
				&& baseRect.left + rect.left > 0
			){
				return false;
			}

			//return rect.width > baseRect.width || rect.height > baseRect.height;
			return true;
		},
		move: function(x, y){
			try{
				var matrix = this.canvasMatrix();
				// if(
				// 	force !==true
				// 	//&& this.isMoveEnable()==false
				// ){
				// 	return {x: matrix[4], y: matrix[5]};
				// }
				if(x === 'center'){
					var pos = this.getCenterPoint(true);
					matrix[4] = pos.x;
					matrix[5] = pos.y;
					matrix = this.canvasMatrix(matrix);
				}else if(isNaN(x)==false && isNaN(y)==false){
					//matrix[4] = x * matrix[0];
					//matrix[5] = y * matrix[3];
					//matrix = this.canvasMatrix(matrix);
					//return {x: matrix[4] / matrix[0], y: matrix[5] / matrix[3]};
					
					matrix[4] = x;
					matrix[5] = y;
					matrix = this.canvasMatrix(matrix);
				}else{
					//return {x: matrix[4] / matrix[0], y: matrix[5] / matrix[3]};
				}
				return {x: matrix[4], y: matrix[5]};
			}finally{
			}
		},
		canvasMatrix: function(matrix){
			var currMatrix;
			var options = Data[this.id].options;
			var ratio = options.ratio;

			if(matrix){
				if(Array.isArray(matrix)){
				}else{
					matrix = matrix.split(',');
					for(var i=0; i<matrix.length; i++){
						matrix[i] = parseFloat(matrix[i]);
					}
				}

				var zoom = matrix[0];
				//var zoom = options.zoom;
				if(zoom < 0.1 || zoom > 8) return this.canvasMatrix();
				
				var ratioZoom = zoom * ratio;
				
				var tX = matrix[4];// / ratio;
				var tY = matrix[5];// / ratio;

				// min max position
				{
					currMatrix = this.canvasMatrix();
					var baseRect = this.elements.baseEl.getBoundingClientRect();
					var canvasRect = this.elements.canvas.getBoundingClientRect();

					var gapLeft = 0;
					if(canvasRect.width < baseRect.width){
						gapLeft = (baseRect.width - canvasRect.width) / 2;
					}
					var maxX = ((options.canvasWidth * ratioZoom) - options.canvasWidth) / 2 + gapLeft;
					var minX = (canvasRect.width - baseRect.width - maxX) * -1
					// console.log('@@@@ min[%f], max[%f]', minX, maxX, tX, ratioZoom)
					tX = Math.max(tX, minX);
					tX = Math.min(tX, maxX);

					var gapTop = 0;
					if(canvasRect.height < baseRect.height){
						gapTop = (baseRect.height - canvasRect.height) / 2;
					}
					var maxY = ((options.canvasHeight * ratioZoom) - options.canvasHeight) / 2 + gapTop;
					var minY = (canvasRect.height - baseRect.height - maxY) * -1
					// console.log('@@@@ min[%f], max[%f]', minY, maxY, tX, ratioZoom)
					tY = Math.max(tY, minY);
					tY = Math.min(tY, maxY);
				}

				var transform = ''
							//+ 'scale('+matrix[0]+', '+matrix[3]+')'
							+ ' translate(' + tX + 'px, ' + tY + 'px)'
							+ ' scale('+ratioZoom+', '+ratioZoom+')'
							;
				this.elements.canvas.style.transform = transform;
				this.elements.drawingCanvas.style.transform = transform;
			}

			var style = this.elements.window.getComputedStyle(this.elements.canvas, null);
			if(style.transform && style.transform !== 'none'){
				var st = style.transform.indexOf('(')+1;
				currMatrix = style.transform.substring(st, style.transform.length - 1).split(', ');
				for(var i=0; i<currMatrix.length; i++){
					currMatrix[i] = parseFloat(currMatrix[i]);
				}
				currMatrix[0] = currMatrix[3] = currMatrix[0] / ratio;
				//currMatrix[4] *= ratio;
				//currMatrix[5] *= ratio;
			}else{
				currMatrix = [1, 0, 0, 1, 0, 0];
			}

			return currMatrix;
		},
		resizeCanvas: function(width, height){
			var options = Data[this.id].options;
			options.canvasWidth = width;
			options.canvasHeight = height;
			
			var chStyle = {
				//'width': (cvsWidth * ratio) + 'px',
				//'height': (cvsHeight * ratio) + 'px',
				'width': width + 'px',
				'height': height + 'px',
			};
			Object.assign(this.elements.canvas.style, chStyle);
			Object.assign(this.elements.drawingCanvas.style, chStyle);
			
			this.getCenterPoint(true);
			
			this.redraw();
			return this;
		},
		/*
		canvas 중심 포인트가 아닌 transform 기준이 될 포인트
		 */
		getCenterPoint: function(remake){
			var cp = Data[this.id].centerPoint;
			if(cp && remake !== true) return cp;
			
			var options = Data[this.id].options;
			var baseRect = this.elements.baseEl.getBoundingClientRect();
			var x = (baseRect.width - options.canvasWidth) / 2;
			var y = (baseRect.height - options.canvasHeight) / 2;
			Data[this.id].centerPoint = cp = {
				x: x, y: y
			};
			//console.log('# grmcvs center point :', x, y);
			return cp;
		},
		redraw: function(){
			var options = Data[this.id].options;
			//options.autoRatio = true;

			var w = this.elements.window;
			var style = w.getComputedStyle(this.target);

			var width = parseFloat( style.getPropertyValue('width') );
			var height = parseFloat( style.getPropertyValue('height') );

			if(!options.canvasWidth){
				let rect = this.target.getBoundingClientRect();
				options.canvasWidth = rect.width;
				options.canvasHeight = rect.height;
			}

			var cvsWidth = options.canvasWidth;
			var cvsHeight = options.canvasHeight;
			var ratio = Math.min(width / cvsWidth, height / cvsHeight);
			options.ratio = ratio;

			// zoom, move
			{
				var currCenterPoint = this.getCenterPoint();
				var matrix = this.canvasMatrix();
	
				this.zoom(options.zoom);
	
				// center
				var centerPoint = this.getCenterPoint(true);
				matrix[4] += (centerPoint.x - currCenterPoint.x);
				matrix[5] += (centerPoint.y - currCenterPoint.y);

				this.move(matrix[4], matrix[5]);
			}
			
			// if(options.autoRatio){
			// 	this.canvasMatrix( matrix );
			// }

			//this.zoom(options.zoom * options.ratio);
//			var chStyle = {
//				//'width': (cvsWidth * ratio) + 'px',
//				//'height': (cvsHeight * ratio) + 'px',
//				'width': width + 'px',
//				'height': height + 'px',
//			};
//			Object.assign(this.elements.canvas.style, chStyle);
//			//Object.assign(this.elements.drawingCanvas.style, chStyle);
		},
		zoomFit: function(){
			var options = Data[this.id].options;
			options.autoRatio = true;
			this.redraw();

			// this.move(0, 0);
			//this.zoom(1, 'center');
			//this.zoom(options.zoom, 'center');
			//this.zoom(1, 'center');
			
			var zoom = options.ratio;
			
//			var baseRect = this.elements.baseEl.getBoundingClientRect();
//			var x = (baseRect.width - options.canvasWidth) / zoom / 2;
//			var y = (baseRect.height - options.canvasHeight) / zoom / 2;
			
			this.zoom(1, 'center');
		},
		zoomOri: function(){
			// TODO 미완
			var options = Data[this.id].options;
			options.autoRatio = false;
			options.ratio = 1;

			this.zoom(1, 'center');
		},
		zoom: function(zoom, movePoint){
			// var style = this.elements.window.getComputedStyle(this.elements.canvas, null);
			var matrix = this.canvasMatrix();
			// var currZoom = matrix[0];
			var options = Data[this.id].options;
			var currZoom = options.zoom || 1;
			var ratio = options.ratio;

			if(!zoom || zoom <= 0){
				return currZoom;
			}
			
			if(currZoom == zoom){
				// return currZoom;
			}

			options.zoom = zoom;
			// zoom *= options.ratio;
			// currZoom *= options.ratio;

			try{
				var THIS = this;
				var point;
				
				if(movePoint === 'center' || (ratio*zoom) <= 1){
					matrix[0] = matrix[3] = zoom;
					matrix = this.canvasMatrix(matrix);
					
					this.move('center');
				}else{
					// mouse position of base element
					point = movePoint;
					
					if(point){
						// console.log('@@ zoom :', zoom, point && point.x, point && point.y)
						// point 을 중심으로 확대.
						// set zoom
						var move = this.move();
						zoom = this.zoom(zoom);
						
						// 이동된 배율
						var movePointRatio = zoom / currZoom;
						
						var baseRect = this.elements.baseEl.getBoundingClientRect();
						
						var baseCenterX = (baseRect.width / 2),
						baseCenterY = (baseRect.height / 2);
						
						var posX = ((baseCenterX - point.x) / zoom);
						var posY = ((baseCenterY - point.y) / zoom);
						posX = move.x + (posX * movePointRatio - posX);
						posY = move.y + (posY * movePointRatio - posY);

						// console.log('@@@@@ zoom move :', posX, posY, move, point);
						
						this.move(posX, posY, point.force);
					}else{
						var ratio = zoom / currZoom;
						matrix[0] = zoom;
						matrix[3] = zoom;
						matrix[4] /= ratio;
						matrix[5] /= ratio;
						matrix = this.canvasMatrix(matrix);
					}
				}
				
				//return matrix[0];
				return options.zoom;
			}finally{
			}
		},
		addLink: function(link, options){
			var THIS = this;
			var DATA = Data[this.id];

			var data;
			if(typeof link === 'object'){
				data = link;
				link = link.link;
			}else{
				data = {link: link};
			}

			if(link.indexOf('youtu') > -1){
				// TODO create element
				var g = this.createDrawElement();
				g.setAttribute('data-did', data.did || this.createDrawId());
				g.setAttribute('data-toolkit', 'link');
				g.setAttribute('data-link', link);
				g.setAttribute('data-link-service-type', 'youtube');
				Object.assign(g.style, {
					'left': '50px',
					'top': '50px',
				});
				if(data.cssText){
					g.style.cssText = data.cssText;
				}

				var el = document.createElement('div');
				g.appendChild(el);
				el.setAttribute('class', 'grm-g-wrapper');
				el.innerHTML = ''
					+ '<div class="grm-g-header">'
					+ '	<a class="grm-g-service-type"></a>'
					+ '</div>'
					+ '<div class="grm-g-body">'
					+ '	<div class="grm-g-content"></div>'
					+ '	<div class="grm-g-content-cover">'
					+ '		<span class="grm-cvs-btn-play" data-g-btn></span>'
					+ '</div>'
					+ '</div>'
					+ '<div class="grm-g-footer">'
					+ '	<span class="grm-g-title"></span>'
					+ '</div>';

				var stLink = g.querySelector('.grm-g-service-type');
				stLink.innerText = 'YouTube';
				stLink.href = link;
				stLink.target = '_grm_link_' + g.getAttribute('data-did');

				var cId = '_grm-yt-el-' + Utils.createId();
				var content = g.querySelector('.grm-g-content');
				content.setAttribute('id', cId);

				this.addDrawElements(g, {
					publishEvent: false
				});
				data.did = g.getAttribute('data-did');

				GrmYouTube.init()
				.then(function(){
					return GrmYouTube.createPlayer(cId, link, {
						onStateChange: onStateChange.bind(THIS)
					});
				})
				.then(function(player){
					if(!options || options.publishEvent !== false){
						DATA.GrmEvent.trigger('addLink', data);
					}

					g.player = player;

					g.setAttribute('data-grm-play-state', 'ready');
					var rect = g.getBoundingClientRect();
					Object.assign(g.style, {
						'width': rect.width + 'px',
						'height': rect.height + 'px',
					});
					if(data.cssText){
						g.style.cssText = data.cssText;
					}

					var videoData = player.getVideoData();
					g.querySelectorAll('.grm-g-title').forEach(function(t){
						t.innerText = t.title = videoData.title;
					});

					g
					._on('click', function(e){
						var el = e.target;
						if(el.matches('.grm-cvs-btn-play')){
							DATA.GrmEvent.trigger('changeMediaElementState', {
								did: g.getAttribute('data-did'),
								state: 'play',
								currentTime: g.player.getCurrentTime()
							});

							if(player.getPlayerState() === GrmYouTube.PlayerState.PLAYING){
								g.setAttribute('data-grm-play-state', 'playing');
							}

							player.playVideo();
						}
					})
					._on('changestate', function(e){
						this.player._lastData = e.data;
						switch(e.data.state){
						case 'play':
						case 'playing':
							this.player.playVideo();
							break;
						case 'pause':
						case 'paused':
							this.player.pauseVideo();
						}
						if(e.data.currentTime !== undefined){
							this.player.seekTo( e.data.currentTime );
						}
					});
				})
				.catch(function(e){
					console.error(e);
					THIS.removeDrawElements(g);
				});

				function onStateChange(e){
					var pub = false;
					var state = '';
					switch(e.data){
					case GrmYouTube.PlayerState.BUFFERING: // 3
						state = 'buffering';
						break;
					case GrmYouTube.PlayerState.CUED: // 5 : play ready
						state = 'ready';
						break;
					case GrmYouTube.PlayerState.PLAYING: // 1
						pub = true;
						state = 'playing';
						break;
					case GrmYouTube.PlayerState.PAUSED: // 2
					case GrmYouTube.PlayerState.ENDED: // 0
						pub = true;
						state = 'paused';
						break;
					case -1: // error?
						state = 'error';
						break;
					default:
						console.warn('[YT] unknown state :', e.data);
						break;
					}

					g.setAttribute('data-grm-play-state', state);
					if(!document.body.contains(g)) return;

					if(pub){
						// TODO 이벤트를 발생시키지 않는다.
						// console.log('##### 1', state, e.target.getCurrentTime());
						// console.log('##### 2', e.target._lastData.state, e.target._lastData.currentTime);
						var lastData = e.target._lastData;
						if(lastData && state == lastData.state){
							var t = Math.abs(lastData.currentTime - e.target.getCurrentTime());
							if(t < 1.5){
								// console.log('# pass event')
								return;
							}
						}

						DATA.GrmEvent.trigger('changeMediaElementState', {
							did: g.getAttribute('data-did'),
							state: state,
							currentTime: e.target.getCurrentTime()
						});
					}
				}
			}else{
				// TODO
			}
		},
	}); // end of set prototype

	// -- Toolkit S ---------------------------------------------
	var Toolkits = {
		toolkits: {},
		createToolkits: function(grmCvs){
			var t = Object.clone(this.toolkits);
			for(var key in t){
				Object.defineReadOnlyProperties(t[key], {
					'grmCvs': grmCvs
				});
			}
			return t;
		},
		addToolkit: function(toolkitSrc){
			var i_toolkit = new ToolkitInterface(toolkitSrc.name);
			delete toolkitSrc.name;

			// TODO
			var defaultListeners = i_toolkit.listeners;
			var toolkit = Object.assign(i_toolkit, toolkitSrc);
			Object.assign(defaultListeners, toolkit.listeners);
			toolkit.listeners = defaultListeners;
			
			this.toolkits[toolkit.name] = toolkit;
			return toolkitSrc;
		}
	}

	var ToolkitInterface = function(toolkitName){
		Object.defineProperties(this, {
			'name': {
				value: toolkitName,
				writable: false,
				enumerable: true
			},
			'type': {
				value: toolkitName,
				writable: false,
				enumerable: true
			}
		});

		Object.assign(this, {
			data: {
				drawing: false
			},
			reloadStyle: function(){},
			preChange: function(options){},
			afterChange: function(options){},
			createId: function(){
				return this.grmCvs.createDrawId();
			},
			getBaseEl: function(){
				if(this.data.baseEl){
					return this.data.baseEl;
				}
				this.data.baseEl = this.grmCvs.elements.canvas;
				return this.data.baseEl;
			},
			getPoint: function(event, baseEl, ratio){
				// var tc = this.grmCvs.elements.baseEl;
				// if(!baseEl && event.target !== tc){
				if(!baseEl){
					// baseEl = this.grmCvs.elements.baseEl;
					// baseEl = this.grmCvs.elements.canvas;
					baseEl = this.getBaseEl();
				}
				var point = Utils.getPoint(event, baseEl);
				// return [point.x, point.y];

				if(ratio !== undefined){
					//ratio = Data[this.grmCvs.id].options.ratio;
					point.x /= ratio;
					point.y /= ratio;
				}

				return point;
			},
			getOffsetPoint: function(e){
				return Utils.getOffsetPoint(e);
			},
			createElement: function(e){
				var el = SvgUtils.createElement('path');
				return el;
			},
			draw: function(pointList, pathEl, options){
				// quadratic curve
				var drawList = [];
				drawList.push('M' + pointList[0]);
				drawList.push(pointList[1]);
				for(var i=2, len=pointList.length-4; i<len; i+=2){
					var midX = (pointList[i] + pointList[i + 2]) / 2,
						midY = (pointList[i+1] + pointList[i+3]) / 2;
					drawList.push('Q' + pointList[i]);
					drawList.push(pointList[i+1]);
					drawList.push(parseFloat(midX.toFixed(2)));
					drawList.push(parseFloat(midY.toFixed(2)));
				}
				pathEl.setAttributeNS(null, 'd', drawList.join(' '));
				// this.data.path.setAttributeNS(null, 'd', SvgUtils.svgPath(pointList));
			},
			drawLine: function(pointList, lineEl, options){
				lineEl.setAttributeNS(null, 'x1', pointList[0]);
				lineEl.setAttributeNS(null, 'y1', pointList[1]);
				lineEl.setAttributeNS(null, 'x2', pointList[2]);
				lineEl.setAttributeNS(null, 'y2', pointList[3]);
			},
			trigger: function(e){
				if(!this.listeners || !this.listeners[e.type]){
					return;
				}
				return this.listeners[e.type].call(this, e);
			},
			listeners: {
				hotkeyUp: function(e){
					var key = e.key.toLowerCase();
					switch(key){
					case 'z':
						if(e.ctrlKey){
							Data[this.grmCvs.id].Job[
								e.shiftKey ? 'redo' : 'undo'
							]();
							return;
						}
						break;
					case 'y':
						if(e.ctrlKey){
							Data[this.grmCvs.id].Job.redo();
							return;
						}
						break;
					case 'v':
						if(e.ctrlKey){
							this.grmCvs.pasteDrawElements();
						}
						break;
					case 'arrowup':
						if(e.ctrlKey){
							Data[this.grmCvs.id].toolkits['select']
							.setSelectedElementsTransform('arrange', {
								arrangeValue: e.shiftKey ? 'front' : 'forward'
							});
							return;
						}
						break;
					case 'arrowdown':
						if(e.ctrlKey){
							Data[this.grmCvs.id].toolkits['select']
							.setSelectedElementsTransform('arrange', {
								arrangeValue: e.shiftKey ? 'back' : 'backward'
							});
							return;
						}
						break;
					case '+':
					case '-':
						this.grmCvs.zoom( this.grmCvs.zoom() + (key === '+' ? 0.1 : -0.1) );
						break;
					}
				},
				hotkeyDown: function(e){
					switch(e.key.toLowerCase()){
					case ' ': // spacebar
						// move
						this.grmCvs.changeTransientToolkit('move', {
							cancelEvent: 'keyup'
						});
					}
				},
				contextmenu: function(e){
					console.log('context menu :', this.name);
				}
			},
			mouseover: function(event){},
			mousedown: function(event){},
			mousemove: function(event){},
			mouseup: function(event){},
			mouseout: function(event){},
			wheel: function(event){
				if(event.altKey || event.ctrlKey || event.shiftKey){
					return;
				}
				
				var currZoom = this.grmCvs.zoom();
				var zoom = currZoom + (event.deltaY >= 0 ? -0.1 : 0.1);

				// 현재 마우스 위치
				var point = this.getPoint(event);
				
				zoom = this.grmCvs.zoom(zoom, point);
				var move = this.grmCvs.move();
				
				if(currZoom != zoom){
					Data[this.grmCvs.id].GrmEvent.trigger('zoom', {
						zoom: zoom,
						moveX: move.x,
						moveY: move.y
					});
				}
			},
			defaultMouseButton: function(event, useButtons){
				var button = event.button;
				if(button === undefined || button===0){
					return;
				}

				if(!useButtons){
					useButtons = [1, 2];
				}

				if( Data[this.grmCvs.id].options.useToolkitDefaultMouseButton === false ){
					return;
				}

				function chk(){
					return useButtons && useButtons.indexOf(button) > -1;
				}

				// 1 : wheel, 2 : right click
				switch(button){
				case 0:
					return;
				case 1:
					if(chk()){
						this.grmCvs.changeTransientToolkit('move', {event: event});
						break;
					}
				case 2:
					if(chk()){
						this.grmCvs.changeTransientToolkit('laserpointer', {event: event});
						break;
					}
				}

				return true;
			}
		});
	}
	var ToolkitPrototype = new ToolkitInterface('prototype');

//elements.canvas.addEventListener('mouseover')
	Toolkits.addToolkit({
		name: 'select',
		style: {
			base: {
				'cursor': 'default',
			},
			pathAttr: {
				'stroke-linecap': 'round',
				'stroke-linejoin': 'round'
			},
			path: {
				'stroke': '#000000',
				'stroke-width': '5px',
				// 'opacity': '1',
				'fill': 'none'
			}
		},
		getBaseEl: function(){
			if(this.data.baseEl){
				return this.data.baseEl;
			}
			this.data.baseEl = this.grmCvs.elements.baseEl;
			return this.data.baseEl;
		},
		clearSelectedElements: function(exList){
			this.getSelectedElements().forEach(function(el){
				// el.removeAttribute('data-grm-selected');
				el._trigger('grm-g-unselected');
			});
		},
		getSelectedElements: function(){
			return this.grmCvs.elements.baseEl.querySelectorAll('[data-g][data-grm-selected]');
		},
		getAllElements: function(){
			return this.grmCvs.getAllElements();
		},
		selectElements: function(els, clearCurrentSelected){
			if(Array.isArray(els) || els instanceof NodeList){
				if(clearCurrentSelected !== false){
					this.clearSelectedElements();
				}
				els.forEach(el => {
					this.selectElements(el, false);
				});
				console.log('#grm-cvs : selected[%d]', els.length)
				return;
			}

			if(clearCurrentSelected !== false){
				this.clearSelectedElements();
			}

			if(this.grmCvs.isDrawElement(els)){
				els.setAttribute('data-grm-selected', 'true');
			}
		},
		selectAllElements: function(){
			this.selectElements( this.getAllElements() );
		},
		setSelectedElementsTransform: function(type, data, els){
			var grmCvs = this.grmCvs;
			var baseRect = grmCvs.elements.baseEl.getBoundingClientRect();
			els = els || this.getSelectedElements();
			
			switch(type){
			case 'moveBy':
				els.forEach(function(el){
					el._trigger('grm-transform', {type: type, data: data});
				});
				break;
			case 'arrange':
				switch(data.arrangeValue){
				case 'front':
					els.forEach(function(el){
						el._trigger('grm-transform', {type: type, data: data});
					});
					break;
				case 'back':
					for(var i=els.length-1; i>-1; i--){
						els[i]._trigger('grm-transform', {type: type, data: data});
					}
					break;
				case 'forward':
					// TODO 여러개 이동 미완
					els.forEach(function(el){
						el._trigger('grm-transform', {type: type, data: data});
					// 	var next;
					// 	try{
					// 		next = el.nextElementSibling.nextElementSibling;
					// 	}catch(e){}
					// 	if(next){
					// 		grmCvs.elements.canvas.insertBefore(el, next);
					// 	}else{
					// 		grmCvs.elements.canvas.appendChild(el);
					// 	}
					});
					break;
				case 'backward':
					// TODO 여러개 이동 미완
					for(var i=els.length-1; i>-1; i--){
						els[i]._trigger('grm-transform', {type: type, data: data});
					// 	var el = els[i];
					// 	var prev = el.previousElementSibling;
					// 	if(prev){
					// 		grmCvs.elements.canvas.insertBefore(el, prev);
					// 	}else{
					// 		grmCvs.elements.canvas.prepend(el);
					// 	}
					}
					break;
				}
			}
		},
		listeners: {
			hotkeyUp: function(e){
				switch(e.key.toLowerCase()){
				case 'a':
					if(e.ctrlKey){
						e.preventDefault();
						e.stopPropagation();
						this.selectAllElements();
						return false;
					}
					break;
				case 'c':
					if(e.ctrlKey){
						// TODO
						var copyElements = [];
						this.getSelectedElements().forEach(function(el){
							copyElements.push( el.cloneNode(true) );
						});
						if(copyElements.length > 0){
							this.grmCvs.copyDrawElements(copyElements);
						}
					}
					break;
				case 'delete':
					this.grmCvs.removeDrawElements( this.getSelectedElements(), {
						addJob: true
					} );
					break;
				case 'escape':
					this.clearSelectedElements();
					break;
				default:
					ToolkitPrototype.listeners.hotkeyUp.call(this, e);
					return;
				}
			},
			hotkeyDown: function(e){
				var tType, data={};
				switch(e.key.toLowerCase()){
				case 'a':
					if(e.ctrlKey){
						e.preventDefault();
						e.stopPropagation();
						this.selectAllElements();
						return false;
					}
					break;
				case 'arrowleft':
					tType = 'moveBy'; data.x = -5;
					break;
				case 'arrowup':
					tType = 'moveBy'; data.y = -5;
					break;
				case 'arrowright':
					tType = 'moveBy'; data.x = 5;
					break;
				case 'arrowdown':
					tType = 'moveBy'; data.y = 5;
					break;
				default:
					ToolkitPrototype.listeners.hotkeyDown.call(this, e);
					return;
				}

				switch(tType){
				case 'moveBy':
					if(e.ctrlKey){
						return;
					}
					if(e.shiftKey){
						if(data.x !== undefined) data.x *= 3;
						if(data.y !== undefined) data.y *= 3;
					}else if(e.altKey){
						if(data.x !== undefined) data.x = data.x > 0 ? 1 : -1;
						if(data.y !== undefined) data.y = data.y > 0 ? 1 : -1;
					}
					this.setSelectedElementsTransform(tType, data);
					break;
				}
			},
			contextmenu: function(e){
				// console.log('# contextmenu :', e.target);

				var ctxMenu = this.data.ctxMenu;
				if(!ctxMenu){
					ctxMenu = this.data.ctxMenu = document.createElement('div');
					ctxMenu.setAttribute('data-grm-cvs', 'ctx-menu');
					ctxMenu.setAttribute('tabindex', '999');

					let options = Data[this.grmCvs.id].options;
					let msg = options.message;
					let exclude = options.excludeContextMenu;
					function createItem(itemType, last){
						if(exclude && exclude.includes(itemType)){
							return;
						}

						let item = document.createElement('div');
						item.setAttribute('data-grm-ctx-item', '');
						item.setAttribute('data-grm-ctx-item-type', itemType);
						if(last){
							item.classList.add('uline');
						}
						if(itemType){
							item.innerHTML = msg['ctxmenu.' + itemType] || itemType;
						}
						ctxMenu.appendChild(item);
						return item;
					}

					['copy', 'copy_paste', 'paste'].forEach(function(m, idx, arr){
						// createItem(m, idx === arr.length-1);
						createItem(m);
					});
					createItem(null, true);
					['remove'].forEach(function(m, idx, arr){
						createItem(m);
					});
					createItem(null, true);
					['front', 'back', 'forward', 'backward'].forEach(function(m, idx, arr){
						// createItem('arrange.'+m, idx === arr.length-1);
						createItem('arrange.'+m);
					});
					createItem(null, true);

					ctxMenu.addEventListener('click', (function(e){
						var els = ctxMenu.els;
						ctxMenu._trigger('blur');
						
						var type = e.target.getAttribute('data-grm-ctx-item-type');
						if(type) type = type.replace('ctxmenu.', '');
						// var el = 

						switch(type){
						case 'copy':
							this.grmCvs.copyDrawElements(els);
							break;
						case 'copy_paste':
							this.grmCvs.pasteDrawElements(els);
							break;
						case 'paste':
							this.grmCvs.pasteDrawElements();
							break;
						case 'remove':
							this.grmCvs.removeDrawElements(els);
							break;
						case 'arrange.front':
							this.setSelectedElementsTransform('arrange', {arrangeValue: 'front'}, els);
							break;
						case 'arrange.back':
							this.setSelectedElementsTransform('arrange', {arrangeValue: 'back'}, els);
							break;
						case 'arrange.forward':
							this.setSelectedElementsTransform('arrange', {arrangeValue: 'forward'}, els);
							break;
						case 'arrange.backward':
							this.setSelectedElementsTransform('arrange', {arrangeValue: 'backward'}, els);
							break;
						default:
							break;
						}
					}).bind(this));

					let ctxContainer = (options.contextMenuContainer || this.grmCvs.elements.wrapper);
					ctxContainer.appendChild(ctxMenu);
				}

				delete ctxMenu.els;
				
				var ctxType = 'normal';
				// element 메뉴
				if(e.target.matches('[data-g], [data-g] *')){
					ctxType = 'element';
					var el = e.target.closest('[data-g]');
					if(!el.hasAttribute('data-grm-selected')){
						this.selectElements(el);
					}
					ctxMenu.els = this.getSelectedElements();
				}else{
					var cpEls = Data.group[this.grmCvs.groupId].copyElements;
					var cpLen = (cpEls && cpEls.length) || 0;
					if(cpLen === 0){
						return;
					}
				}
				ctxMenu.setAttribute('data-ctx-type', ctxType);


				var point = this.getPoint(e, ctxMenu.parentElement);
				ctxMenu.style.left = point.x + 'px';
				ctxMenu.style.top = point.y + 'px';

				ctxMenu.style.display = 'block';
				try{
					ctxMenu.focus();
				}catch(e){}
				ctxMenu.addEventListener('blur', function(e){
					delete ctxMenu.els;
					this.style.display = 'none';
				}, {once: true});
			},
			dragSelectBox: {
				mousedown: function(e){
					var THIS = this;
					
					if(THIS.data._draging_select_box){
						return;
					}
					THIS.data._draging_select_box = true;

					var box = this.data.dragSelectBox;
					if(!box){
						box = this.data.dragSelectBox = document.createElement('div');
						box.setAttribute('data-grm-cvs', 'drag-box');
						this.grmCvs.elements.baseEl.appendChild(box);
					}

					var data = {
						point: this.getPoint(e),
						width: parseInt(box.style.width || 0),
						height: parseInt(box.style.height || 0),
					};

					Object.assign(box.style, {
						display: 'block',
						left: data.point.x + 'px',
						top: data.point.y + 'px',
						width: '1px',
						height: '1px',
					});

					this.grmCvs.elements.baseEl.setAttribute('data-drag-select-mode', 'true');

					var baseRect = this.grmCvs.elements.baseEl.getBoundingClientRect();
					var cvsRect = this.grmCvs.elements.canvas.getBoundingClientRect();
					var gapLeft = baseRect.left - cvsRect.left;
					var gapTop = baseRect.top - cvsRect.top;
					var options = Data[this.grmCvs.id].options;
					var zoom = options.zoom * options.ratio;

					const EVENT_TARGET = (e.type.startsWith('mouse') || e.type.startsWith('pointer'))
										? this.grmCvs.elements.window
										: this.getBaseEl();

					Object.assign(data, {
						mousemove: function(data, e){
							var box = this.data.dragSelectBox;
							if(!box) return;

							var point = this.getPoint(e);

							var left = data.point.x,
								top = data.point.y;

							var width = point.x - data.point.x,
								height = point.y - data.point.y;

							box.style.display = 'block';
							if(width < 0){
								left = point.x;
								width = Math.abs(width);
							}
							if(height < 0){
								top = point.y;
								height = Math.abs(height);
							}

							if(width < 2 && height < 2){
								return;
							}

							// dragbox resize
							{
								box.style.left = left + 'px';
								box.style.top = top + 'px';
								box.style.width = width + 'px';
								box.style.height = height + 'px';
							}

							// console.log('## test 1 : lt[%d,%d], rect[%d,%d], zoom[%f,%f,%f], gap[%d,%d]',
							// 	left, top, cvsRect.left, cvsRect.top, zoom, options.zoom, options.ratio, gapLeft, gapTop);
							var rLeft = (left + gapLeft) / zoom,
								rTop = (top + gapTop) / zoom,
								rRight = rLeft + (width / zoom),
								rBottom = rTop + (height / zoom);
							// console.log('## test 2 :', rLeft, rTop, rRight, rBottom);

							var list = this.getAllElements();
							for(var i=0, len=list.length; i<len; i++){
								var el = list[i];
								var eLeft = parseInt(el.style.left),
									eTop = parseInt(el.style.top);
								var eRight = eLeft + parseInt(el.style.width || el.offsetWidth),
									eBottom = eTop + parseInt(el.style.height || el.offsetHeight);

								if(
									eLeft <= rRight &&
									eRight >= rLeft &&
									eTop <= rBottom &&
									eBottom >= rTop
								){
									el.setAttribute('data-grm-drag-intersection', 'true');
								}else{
									el.removeAttribute('data-grm-drag-intersection');
								}
							}
						},
						mouseup: function(data, e){
							THIS.data._draging_select_box = false;

							this.grmCvs.elements.baseEl.removeAttribute('data-drag-select-mode');
							['mousemove', 'mouseup'].forEach(type => {
								Events.removeEventListener(EVENT_TARGET, type, data[type]);
							});

							try{
								if(this.data.dragSelectBox)
									this.data.dragSelectBox.style.display = 'none';
							}catch(e){
								console.error(e);
							}
							data = null;

							var list = this.grmCvs.elements.canvas.querySelectorAll('[data-grm-drag-intersection]');
							list.forEach(function(el){
								//el.removeAttribute('data-grm-drag-intersection');
								//el.setAttribute('data-grm-selected', 'true');
								el._trigger('grm-g-selected', {multiSelect: true});
							});
							//if(list.length > 0)
							//	console.log('drag selected :', list);
						}
					});

					var eTypes = ['mousemove', 'mouseup'];
					eTypes.forEach(type => {
						data[type] = data[type].bind(THIS, data);
						Events.addEventListener(EVENT_TARGET, type, data[type], {once: type === 'mouseup'});
					});
					// Events.setEvents(eTypes, (type, oriType) => {
					// 	EVENT_TARGET.addEventListener(
					// 		type, data[oriType],
					// 		{
					// 			once: oriType == 'mouseup',
					// 			passive: !oriType.startsWith('mouse')
					// 		}
					// 	);
					// });
				}
			},
			svgElement: {
				mousedown: function(e){
					if(e.button && e.button !== 0){
						return;
					}

					var THIS = this;

					var el = e.target;
					var type = 'move';
					var resizeType, rotateType;

					if(el.nodeName && el.nodeName.toLowerCase() === 'a'){
						return;
					}else if(el.hasAttribute('data-g-btn')){
						return;
					}else if(el.matches('[data-g] > [data-type="resize-dot"]')){
						type = 'resize';
						resizeType = el.getAttribute('data-resize-type');
						el = el.closest('[data-g]');
						// // TODO
						// if(e.altKey) type = 'rotate';
					}else if(el.matches('[data-g] > [data-type="rotate-dot"]')){
						type = 'rotate';
						rotateType = el.getAttribute('data-rotate-type');
						el = el.closest('[data-g]');
					}else if(el.matches('[data-g] *')){
						el = el.closest('[data-g]');
					}else if(!el.matches('[data-g]')){
						this.clearSelectedElements();
						this.listeners.dragSelectBox.mousedown.call(this, e);
						return;
					}
					// e.stopPropagation();

					var selected = el.hasAttribute('data-grm-selected');

					if(selected){
						if(e.shiftKey && type !== 'resize'){
							//el.removeAttribute('data-grm-selected');
							//el._trigger('destroy');
							el._trigger('grm-g-unselected');
							return;
						}
					}else{
						if(!e.shiftKey){
							this.clearSelectedElements();
						}
						// el.setAttribute('data-grm-selected', 'true');
						el._trigger('grm-g-selected');
					}

					if(THIS.data._start_svgElement){
						return;
					}
					THIS.data._start_svgElement = true;

					// const EVENT_TARGET = e.type.startsWith('mouse') ? this.grmCvs.elements.window : this.getBaseEl();
					// const EVENT_TARGET = this.grmCvs.elements.window;
					const EVENT_TARGET = (e.type.startsWith('mouse') || e.type.startsWith('pointer'))
										? this.grmCvs.elements.window
										: this.getBaseEl();

					var point = this.getPoint(e);

					var options = Data[this.grmCvs.id].options;
					var globalInfo = {
						type: type,
						resizeType: resizeType,
						rotateType: rotateType,
						options: options,
						baseRect: this.grmCvs.elements.baseEl.getBoundingClientRect(),
						canvasRect: this.grmCvs.elements.canvas.getBoundingClientRect(),
						zoom: options.zoom * options.ratio,
						docBodyInfo: (function(){
							var data = {
								pointerEvents: document.body.style.pointerEvents,
								ondragstart: document.body.ondragstart,
								onselectstart: document.body.onselectstart,
							};
							document.body.style.pointerEvents = 'none';
							document.body.ondragstart = document.body.onselectstart = function(){
								return false;
							}
							return data;
						}()),
						jobData: {},
						selectedList: this.getSelectedElements()
					};
					Object.assign(globalInfo, {drggableArea: {
						left: Math.max(globalInfo.baseRect.left, globalInfo.canvasRect.left),
						top: Math.max(globalInfo.baseRect.top, globalInfo.canvasRect.top),
						right: Math.min(globalInfo.baseRect.right, globalInfo.canvasRect.right),
						bottom: Math.min(globalInfo.baseRect.bottom, globalInfo.canvasRect.bottom),
					}})

					globalInfo.selectedList
					.forEach(function(el, idx, arr){
						var draw = el.querySelector('[data-draw]');

						var scale = SvgUtils.getTransform(draw, 'scale'),
							translate = SvgUtils.getTransform(draw, 'translate');

						var style = window.getComputedStyle(el);
						var targetInfo = el.targetInfo = Object.assign({}, point, {
							globalInfo: globalInfo,
							last: idx === arr.length - 1,
							scale: scale,
							translate: translate,
							left: parseInt(el.style.left),
							top: parseInt(el.style.top),
							width: parseInt(style.width),
							widthMargin: (function(){
								return parseInt(style.paddingLeft)
									+ parseInt(style.paddingRight)
									+ parseInt(style.marginLeft)
									+ parseInt(style.marginRight);
							}()),
							height: parseInt(style.height),
							heightMargin: (function(){
								return parseInt(style.paddingTop)
									+ parseInt(style.paddingBottom)
									+ parseInt(style.marginTop)
									+ parseInt(style.marginBottom);
							}()),
							aspectRatio: parseInt(style.height) / parseInt(style.width),
							transform: el.style.transform,
							scaleX: scale && scale.matrix.a,
							scaleY: scale && scale.matrix.d,
							translateX: translate && translate.matrix.e,
							translateY: translate && translate.matrix.f,
							rect: el.getBoundingClientRect(),
							drawRect: draw && draw.getBoundingClientRect()
						});
						Object.assign(targetInfo, {
							rectWidth: targetInfo.width + targetInfo.widthMargin,
							rectHeight: targetInfo.height + targetInfo.heightMargin,
							oriRect: (function(){
								if(!scale) return null;
								scale.setScale(1, 1);
								var rect = draw.getBoundingClientRect();
								scale.setScale(targetInfo.scaleX, targetInfo.scaleY);
								return rect;
							}()),
							// width: targetInfo.width + (targetInfo.rect.width - targetInfo.width),
							// height: targetInfo.height + (targetInfo.rect.height - targetInfo.height),
							mousemove: function(targetInfo, e){
								// if(e.shiftKey){
								// 	return;
								// }
								var tInfo = targetInfo || el.targetInfo;
								var point = this.getPoint(e);
								tInfo.lastPoint = point;

								var x = (point.x - tInfo.x) / tInfo.globalInfo.zoom;
								var y = (point.y - tInfo.y) / tInfo.globalInfo.zoom;
								// var x = (point.x - tInfo.x);
								// var y = (point.y - tInfo.y);
								var nX = 1, nY = 1;

								// console.log('# el transform move :', point);
								
								switch(tInfo.globalInfo.type){
								case 'rotate': // TODO 개발중
									if(tInfo._rotate === undefined){
										tInfo._rotate = 0;
										var transform = el.style.transform;
										if(transform){
											var st = transform.indexOf('rotate(');
											if(st > -1){
												tInfo._rotate = transform.substring(st+7, transform.indexOf('deg', st));
												tInfo._rotate = parseFloat(tInfo._rotate);
												if(isNaN(tInfo._rotate)){
													tInfo._rotate = 0;
												}
											}
											console.log('@@ current rotate :', tInfo._rotate);
										}
									}

									if(!tInfo._rotatePoint){
										tInfo._rotatePoint = {
											// cX: (tInfo.rect.x * tInfo.globalInfo.zoom) + (tInfo.rect.width/2),
											// cY: (tInfo.rect.y * tInfo.globalInfo.zoom) + (tInfo.rect.height/2),
											cX: el.offsetLeft + (el.offsetWidth/2),
											cY: el.offsetTop + (el.offsetHeight/2),
										};
										tInfo._rotatePoint.x = tInfo.x - tInfo._rotatePoint.cX;
										tInfo._rotatePoint.y = tInfo.y - tInfo._rotatePoint.cY;
									}

									var _x = point.x - tInfo._rotatePoint.cX;
									var _y = point.y - tInfo._rotatePoint.cY;
									// console.log('@@@@@@@@ ', tInfo._rotatePoint.cX, tInfo._rotatePoint.cY, ' /', tInfo._rotatePoint.x, tInfo._rotatePoint.y, ' /',  _x, _y);
									// console.log('@@@@@@@@ ', tInfo.x, tInfo.y, ' /', point.x, point.y, ' /',  el.offsetLeft, el.offsetTop);
									var dx = _x - tInfo._rotatePoint.x;
									var dy = _y - tInfo._rotatePoint.y;
									var d = Math.atan(dy/dx) * (180.0/Math.PI);
									
									var t = 0;
									switch(tInfo.globalInfo.rotateType){
									case '0':
									case '2':
										// t = 45 / 2;
										break;
									case '1':
									case '3':
										// t = -45 / 2;
										break;
									}
									d += t;

									if(dx <= 0){
										d += -180;
									}else{
										// if(dy<0.0) d += 360.0;
									}

									d += tInfo._rotate;

									el.style.transform = 'rotate('+d+'deg)';
									break;
								case 'resize':
									switch(tInfo.globalInfo.resizeType){
									case '0':
										nX = -1;
										nY = -1;
										break;
									case '1':
										x = 0;
										nY = -1;
										break;
									case '2':
										nY = -1;
										break;
									case '3':
										nX = -1;
										y = 0;
										break;
									case '4':
										y = 0;
										break;
									case '5':
										nX = -1;
										break;
									case '6':
										x = 0;
										break;
									}

									x *= nX;
									y *= nY;

									if(tInfo.rect){
										if(tInfo.rect.width + x <= 0){
											x = 1 - tInfo.rect.width;
										}
										if(tInfo.rect.height + y <= 0){
											y = 1 - tInfo.rect.height;
										}
									}

									var width = tInfo.width,
										height = tInfo.height,
										left = tInfo.left,
										top = tInfo.top;

									switch(tInfo.globalInfo.resizeType){
									case '0':
										width += x;
										height += y;
										left -= x;
										top -= y;
										break;
									case '1':
										height += y;
										top -= y;
										break;
									case '2':
										width += x;
										height += y;
										top -= y;
										break;
									case '3':
										width += x;
										left -= x;
										break;
									case '4':
										width += x;
										break;
									case '5':
										width += x;
										height += y;
										left -= x;
										break;
									case '6':
										height += y;
										break;
									case '7':
										width += x;
										height += y;
										break;
									}

									if(width < 10) width = 10;
									if(height < 10) height = 10;

									// if(left < 0){
									// 	width += left;
									// 	left = 0;
									// }else if(left + width + tInfo.widthMargin > tInfo.globalInfo.baseRect.width){
									// 	width = tInfo.globalInfo.baseRect.width - left - tInfo.widthMargin;
									// }
									// if(top < 0){
									// 	height += top;
									// 	top = 0;
									// }else if(top + height + tInfo.heightMargin > tInfo.globalInfo.baseRect.height){
									// 	height = tInfo.globalInfo.baseRect.height - top - tInfo.heightMargin;
									// }

									// shiftkey
									+function(){
										if(!e.shiftKey && !tInfo.globalInfo.options.forceAspectRatioSize){
											return;
										}
										var ar = height / width;
										if(ar == tInfo.aspectRatio){
											return;
										}

										switch(tInfo.globalInfo.resizeType){
										case '0':
										case '2':
											var re_h = width * tInfo.aspectRatio;
											top -= re_h - height;
											height = re_h;
											break;
										case '1':
										case '6':
											width = height / tInfo.aspectRatio;
											break;
										case '3':
										case '4':
										case '5':
										case '7':
											height = width * tInfo.aspectRatio;
											break;
										}
									}();
									
									// scale
									if(tInfo.scale){
										var scaleX = width / tInfo.width,
											scaleY = height / tInfo.height;
											try{
												scale.setScale(tInfo.scaleX * scaleX, tInfo.scaleY * scaleY);
											}catch(e){
												console.error('setScale error', el, scaleX, scaleY, e);
												return;
											}
									}

									el.style.left = left + 'px';
									el.style.top = top + 'px';
									el.style.width = width + 'px';
									el.style.height = height + 'px';
									break; // end of resize
								default: // position
									var left = (tInfo.left + x),
										top = (tInfo.top + y);

									// drag
									(()=>{
										var dragout = !!tInfo.globalInfo.cvsDragEnterId;
										var drggableArea = tInfo.globalInfo.drggableArea;
										var dragPoint = Utils.getPoint(e);
										// console.log('## dragPoint[%d,%d], base[%d,%d,%d,%d][%dx%d]',
										// 	dragPoint.x, dragPoint.y,
										// 	baseRect.left, baseRect.top, baseRect.right, baseRect.bottom,
										// 	baseRect.width, baseRect.height
										// );
										
										var n = 50;
										// 좌측 넘어감
										if(dragPoint.x < drggableArea.left){
											dragout = true;
											// left = n + tInfo.globalInfo.options.canvasWidth;
										}
										// 우측 넘어감
										else if(dragPoint.x > drggableArea.right){
											dragout = true;
											// left = tInfo.globalInfo.options.canvasWidth - n;
										}
										// 상단 넘어감
										if(dragPoint.y < drggableArea.top){
											dragout = true;
											// top = n - tInfo.globalInfo.options.canvasHeight;
										}
										// 하단 넘어감
										else if(dragPoint.y > drggableArea.bottom){
											dragout = true;
											// top = tInfo.globalInfo.options.canvasHeight - n;
										}
										
										// 다른 grm cvs 로 drag
										var isDragOver = false;
										if(dragout){
											// console.log('## dragout!!');
											left = tInfo.left, top = tInfo.top;

											var gPoint = Utils.getPoint(e);
											var cvsList = Data.group[this.grmCvs.groupId].cvsList;
											for(var c=0, len=cvsList.length; c<len; c++){
												var cvs = cvsList[c];
												if(cvs === this.grmCvs) continue;
												if(!cvs.isDragOverCanvas(gPoint)){
													continue;
												}
												// console.log('###### dragover cvs!! :', cvs.id);
												
												var dEventType = 'cvs-drag';
												if(tInfo.globalInfo.cvsDragEnterId !== cvs.id){
													dEventType = 'cvs-dragenter';
													tInfo.globalInfo.cvsDragEnterId = cvs.id
												}
												
												isDragOver = true;
												Data[cvs.id].GrmEvent
												.trigger(dEventType, {
													cvs: this.grmCvs,
													dragList: tInfo.globalInfo.selectedList,
													originalEvent: e
												});
	
												left = tInfo.left;
												top = tInfo.top;
												break;
											}
										}
										if(!isDragOver && tInfo.globalInfo.cvsDragEnterId){
											var cvs = Data[tInfo.globalInfo.cvsDragEnterId].grmCvs;
											Data[cvs.id].GrmEvent
											.trigger('cvs-dragout', {
												cvs: this.grmCvs
											});
											tInfo.globalInfo.cvsDragEnterId = null;
										}
									})(); // end of drag

									el.style.left = left + 'px';
									el.style.top = top + 'px';
									break;
								}
							},
							mouseup: function(targetInfo, e){
								// console.log('@@mouseup :', e.type, el, targetInfo);
								if(targetInfo.ended){
									return;
								}
								targetInfo.ended = true;

								THIS.data._start_svgElement = false;

								var grmCvs = this.grmCvs;
								// delete Data.group[this.grmCvs.groupId].currentTranslateInfo;
							
								Events.removeEventListener(EVENT_TARGET, 'mousemove', targetInfo['mousemove']);
								Events.removeEventListener(grmCvs.elements.canvas, 'mouseout', targetInfo['mouseout']);

								if(!el.hasAttribute('data-grm-selected')){
									// TODO 의문의 코드??
									// selectBox.style.pointerEvents = '';
								}
								
								if(targetInfo.globalInfo.docBodyInfo){
									document.body.style.pointerEvents = targetInfo.globalInfo.docBodyInfo.pointerEvents;
									document.body.ondragstart = targetInfo.globalInfo.docBodyInfo.ondragstart;
									document.body.onselectstart = targetInfo.globalInfo.docBodyInfo.onselectstart;
								}else{
									
								}

								var jobData = targetInfo.globalInfo.jobData;
								jobData.did = jobData.did || [];
								jobData.transform = jobData.transform || [];

								jobData.did.push(el.getAttribute('data-did'));
								var transformData = {
									before: {
										left: targetInfo.left + 'px',
										top: targetInfo.top + 'px',
										width: targetInfo.width + 'px',
										height: targetInfo.height + 'px',
										transform: targetInfo.transform,
										scaleX: targetInfo.scaleX,
										scaleY: targetInfo.scaleY,
										// translateX: targetInfo.translateX,
										// translateY: targetInfo.translateY
									},
									after: {
										left: el.style.left,
										top: el.style.top,
										width: el.style.width,
										height: el.style.height,
										transform: el.style.transform,
										scaleX: targetInfo.scale && targetInfo.scale.matrix.a,
										scaleY: targetInfo.scale && targetInfo.scale.matrix.d,
										// translateX: targetInfo.translate && targetInfo.translate.matrix.e,
										// translateY: targetInfo.translate && targetInfo.translate.matrix.f
									}
								};
								jobData.transform.push(transformData);

								if(targetInfo.last){
									if(targetInfo.globalInfo.cvsDragEnterId){
										var cvs = Data[targetInfo.globalInfo.cvsDragEnterId].grmCvs;
										Data[cvs.id].GrmEvent
										.trigger('cvs-drop', {
											cvs: this.grmCvs,
											dragList: targetInfo.globalInfo.selectedList,
											originalEvent: e
										});
									}else{
										var DATA = Data[this.grmCvs.id];
										DATA.Job.addJob('transform', jobData);

										jobData.did.forEach(function(did, idx){
											DATA.GrmEvent.trigger(
												'transform',
												{
													did: did,
													toolkit: el.getAttribute('data-toolkit'),
													transform: jobData.transform[idx].after
												}
											);
										});
									}
									targetInfo.globalInfo.jobData = null;
								}

								targetInfo = null;
								delete el.targetInfo;
							},
							mouseout: function(targetInfo, e){
								// console.log('####### mouseout', e.target);
							}
						});

						var eTypes = ['mousemove', 'mouseup'];
						eTypes.forEach(type => {
							targetInfo[type] = targetInfo[type].bind(THIS, targetInfo);
							Events.addEventListener(EVENT_TARGET, type, targetInfo[type], {once: type === 'mouseup'});
						});
						
						targetInfo['mouseout'] = targetInfo['mouseout'].bind(THIS, targetInfo);
						Events.addEventListener(THIS.grmCvs.elements.canvas, 'mouseout', targetInfo['mouseout'], {once: true});
						// el.addEventListener('destroy', targetInfo['mouseup'], {once: true});
					}); // end of 'selectedList forEach'

					// Data.group[this.grmCvs.groupId].currentTranslateInfo = {
					// 	srcCvsId: this.grmCvs.id,
					// 	srcList: selectedList
					// };
				},
			},
		},
		dblclick: function(e){
			// console.log('# select dblclick', e.target);
			var el;
			if(e.target.matches('[data-toolkit]')){
				el = e.target;
			}else if(e.target.closest('[data-toolkit]')){
				el = e.target.closest('[data-toolkit]');
			}

			if(!el) return;

			var toolkit = this.grmCvs.getToolkit(el.getAttribute('data-toolkit'));
			if(toolkit && toolkit !== this && toolkit.dblclick){
				this.grmCvs.changeToolkit(toolkit);
				toolkit.dblclick(e);
			}
		},
		preChange: function(options){
			var listeners = this.listeners;

			if(!this.data._listener_init){
				for(var type in listeners){
					var types = listeners[type];
					t:for(var key in types){
						var func = types[key];
						if(typeof func === 'string'){
							types[key] = types[func];
							continue t;
						}
						types[key] = (function(toolkit, listener){
							return function _move_eventListener(e){
								// e.preventDefault();
								// e.stopPropagation();
								listener.call(toolkit, e);
							}
							// return listener.bind(this, e);
						}(this, func));
					}
				}
				this.data._listener_init = 1;
			}

			// add event listeners
			{
				var canvas = this.grmCvs.elements.canvas;
				['svgElement'].forEach(function(type){
					var types = listeners[type];
					if(!types) return;
					for(var key in types){
						var listener = types[key];
						Events.addEventListener(canvas, key, listener);
					}
				});
				
				// var baseEl = this.grmCvs.elements.baseEl;
				// ['selectBox'].forEach(function(type){
				// 	var types = listeners[type];
				// 	if(!types) return;
				// 	for(var key in types){
				// 		var listener = types[key];
				// 		baseEl.addEventListener(key, listener);
				// 	}
				// });
			}
		},
		afterChange: function(options){
			// remove event listeners
			{
				var listeners = this.listeners;

				var canvas = this.grmCvs.elements.canvas;
				['svgElement'].forEach(function(type){
					var types = listeners[type];
					if(!types) return;
					for(var key in types){
						var listener = types[key];
						Events.removeEventListener(canvas, key, listener);
					}
				});

				// var baseEl = this.grmCvs.elements.baseEl;
				// ['selectBox'].forEach(function(type){
				// 	var types = listeners[type];
				// 	if(!types) return;
				// 	for(var key in types){
				// 		var listener = types[key];
				// 		baseEl.removeEventListener(key, listener);
				// 	}
				// });
			}

			if(!options || options.once !== true){
				this.clearSelectedElements();
			}

			if(this.data.dragSelectBox){
				this.data.dragSelectBox.remove();
				this.data.dragSelectBox = null;
			}
		},
		mousedown: function(event){
			this.defaultMouseButton(event, [1, 2]);
		},
		mousemove: function(event){
		},
		mouseup: function(event){
		}
	});

	var _toolkit_src_pencil = Toolkits.addToolkit({
		name: 'pencil',
		style: {
			base: {
				// 'cursor': 'crosshair',
				'cursor': "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAArrAAAK6wGCiw1aAAADwElEQVQ4y43Ub2iVdRQH8HN+v+f/vXfP3R/31607Z2wsJXDCtDZyb5q0cigpLBCm6IKQMkQqE0Z/XsgqoaAUS5wUoigWvRHRZmNBlrRNN7bZzN2trU03d+/13vnc5z7P73d6sRcWmnbgvDrw4cuBc5DZ5fs+3lq6fEd9cLj3ZnzCSSvxz77qSTS+9n7fG/v2u14mg6qmETymlMN76ks2r1u6zUrdoLo1ERCZmKtOgFgYO9vhpnZ9oAfD4GVcpqi6RPxviO2sn//JLq0Rvl1OMD8Csekxg5foAXT72rveWXfATcZA1XQg4eOjEvHdxfFs/dmWV5TwMk1eOwSGMwXCCBLk6uDHo3Xz/ZfCv87aF4vKyoVpaIyICB8Sje8xg3amaLTFGbsSQEyBYSBmGxpKBgA5Omhiek1354nCu0OxCyuaXvRIeAwZf2BnfP+xr2MzJw7UcCP6lCdcwQM2UwMW2KaKisrRtbisXZ29OjHStTI5M/ljSe3GJEnBEJDgH8mYtbLOUwpWve3e9i+jZiipewmRJgAM2lCYE4airBBL60JUvlTW7ESPnhzsbCtCxiWRZAD3gyERoZ+M0cRHDcs4DR63qvLrEMkPhAsUIxAClB7EnRTcSS8IRJXf6h29aFfvaK1u+XKKpMeQqRIAAKXwARnnMr0g/ny3vlDJHzpuVhU9jySlESpgRmgJIPiQTCUg5iSkJJXNDQx0Z1fv3F7RfOQmEXEEEEhEAEIAcI4iPksT2xryrLXXO83ayiZy0kK3CpgWKkPGEZyFebqT+EsKUnh8dPhqbmVr69LGQ/3ke3wRAgCQEoAhE9MJOf96QzjzdP83obVVTYBcakYhqlnlyBUV0nenYS42Ljl32eRAdDgR+fzlho2tQ/chACAhADnn6eExkeo5lqcWn/mCFNjMQwGhKrlMzXoSuWGDGxuEZGLKG3G2qt/9bl5/Icdq/Re0qBEACQZMkf7Mz8Fk15ZPeUHedjR14nwJWLkRFGTBH/ca5XSoBsxTh5ndeWriQQgAQBKQn+aomULc/s1M/rChg+WX7OKmS7pZAU5pB0bhCQieOw2Rg0elK31kD79ABNRMAdJHnl/jBBtO74W56EEvqdC40gYL4eVUcaOXyrr6pBuJsJnS4h72yN/AFCLpM6XwmbT13LdvfX+t4sPumZCA7h60hielXLWC3eLyfE773hYgose28DOMiPCX8RE42bzh1fju9lnnkyM01vbmmcTlK8VEBP8LIiIg3wciQud8F1xdv2lL3/pN78Uu9eQuzgT7G3VjBNP3hYvNAAAAAElFTkSuQmCC), auto",
			},
			pathAttr: {
				'stroke-linecap': 'round',
				'stroke-linejoin': 'round'
			},
			path: {
				'stroke': '#000000',
				'stroke-width': '2px',
				// 'opacity': '1',
				'fill': 'none'
			}
		},
		mousedown: function(event){
			if(this.data.drawing){
				return;
			}

			if(this.defaultMouseButton(event)){
				return;
			}

			this.data.drawing = true;
			this.data.drawingCnt = 0;

			var options = Data[this.grmCvs.id].options;
			this.data.tmpData = {
				options: options,
				ratioZoom: options.ratio * options.zoom
			};

			var point = this.getPoint(event, null, this.data.tmpData.ratioZoom);
			// var point = this.getOffsetPoint(event);

			this.data.pointList = [ point.x, point.y ];
			// this.data.pointList = [ point ];

			this.data.path = SvgUtils.createElement('path');
			// this.data.g.appendChild(this.data.path);
			
			this.data.path.setAttribute('data-draw', '');

			for(var key in this.style.pathAttr){
				this.data.path.setAttributeNS(null, key, this.style.pathAttr[key]);
			}
			Object.assign(this.data.path.style, this.style.path, {
				//'pointer-events': 'none'
			});

			var zoom = this.grmCvs.zoom();
			if(zoom !== 1){
				var strokeWidth = parseFloat(this.data.path.style.strokeWidth);
				this.data.path.oriStrokeWidth = strokeWidth;
				// this.data.path.style.strokeWidth = (strokeWidth * zoom) + 'px';
				this.data.path.style.strokeWidth = (strokeWidth) + 'px';
			}

			this.grmCvs.elements.drawingCanvas.appendChild( this.data.path );
			
			// console.log(this.name, ' start :', this.data.startPoint);
		},
		mousemove: function(event){
			if(!this.data.drawing){
				return;
			}

			// if(this.data.drawingCnt++ % 2 === 0){
			// 	return;
			// }

			var point = this.getPoint(event, null, this.data.tmpData.ratioZoom);
			// var point = this.getOffsetPoint(event);

			var pointList = this.data.pointList;

			pointList.push( point.x, point.y );

			// render
			this.draw(pointList, this.data.path);
			// console.log(this.name, ' drawing :', point);
		},
		mouseup: function(event){
			if(!this.data.drawing){
				return;
			}

			this.data.drawing = false;

			// var baseRect = this.grmCvs.elements.baseEl.getBoundingClientRect();
			var baseRect = this.grmCvs.elements.canvas.getBoundingClientRect();
			//var matrix = this.grmCvs.canvasMatrix();
			//var zoom = matrix[0];
			var options = Data[this.grmCvs.id].options;
			var zoom = options.zoom * options.ratio;
			var moveX = 0, moveY = 0;

			// console.log(this.name, ' drawend', matrix, zoom, moveX, moveY);
			// var rectOri = this.data.path.getBoundingClientRect();

			if(zoom != 1){
				var canvasRect = this.grmCvs.elements.canvas.getBoundingClientRect();
				moveX = parseFloat(
							//((baseRect.left - canvasRect.left) / zoom).toFixed(2)
							((baseRect.left - canvasRect.left)).toFixed(2)
						);
				moveY = parseFloat(
							//((baseRect.top - canvasRect.top) / zoom).toFixed(2)
							((baseRect.top - canvasRect.top)).toFixed(2)
						);
			}

			var baseMargin = parseFloat(this.style.path['stroke-width']);//+ 10;
			if(this.data.path.oriStrokeWidth){
				this.data.path.style.strokeWidth = this.data.path.oriStrokeWidth + 'px';
			}

			var rect = this.data.path.getBoundingClientRect();
			var left = (rect.left - baseRect.left) / zoom - (baseMargin/2);
			var top = (rect.top - baseRect.top) / zoom - (baseMargin/2);
			var width = (rect.width) / zoom + (baseMargin);
			var height = (rect.height) / zoom + (baseMargin);

			// create svg
			{
				var svg = SvgUtils.createElement('svg');
				
				var scale = svg.createSVGTransform();
				scale.setScale(1, 1);
				this.data.path.transform.baseVal.appendItem(scale);
				
				var translate = svg.createSVGTransform();
				translate.setTranslate(-left, -top);
				this.data.path.transform.baseVal.appendItem(translate);
				
				svg.appendChild(this.data.path);
			}
			// create g
			{
				var g = this.grmCvs.createDrawElement();
				g.appendChild(svg);
				g.setAttribute('data-toolkit', this.name);
				Object.assign(g.style, {
					// 'position': 'absolute',
					// 'left': (left + (zoom!=1?1/zoom:0) + moveX) + 'px',
					// 'top': (top + (zoom!=1?1/zoom:0) + moveY) + 'px',
					'left': (left + moveX) + 'px',
					'top': (top + moveY) + 'px',
					'width': width + 'px',
					'height': height + 'px',
				});

				this.grmCvs.addDrawElements(g, {
					addJob: true,
					jobData: { el: g }
				});
			} // end of create g

			// // TODO 재보정
			// {
			// 	var rectAfter = this.data.path.getBoundingClientRect();
			// 	translate.setTranslate(
			// 		-left -((rectAfter.left - rectOri.left) / zoom),
			// 		-top -((rectAfter.top - rectOri.top) / zoom)
			// 	);
			// }

			delete this.data.tmpData;
			delete this.data.pointList
			this.data.g = this.data.path = null;

			return svg;
		}
	});

	Toolkits.addToolkit(
		Object.assign(
			Object.clone(_toolkit_src_pencil),
			{
				name: 'highlighter',
				style: {
					base: {
						// 'cursor': 'crosshair',
						'cursor': "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAArrAAAK6wGCiw1aAAAEE0lEQVQ4y32Tf0zUdRzGn/fne3A/kePuoJDfKYogOzTBNHWw5o82aq7V5sQMjKQ/HJcza260UZvOTDc0V3lqmU0zf4wtd2i2FH8kjiQh6JAhGKQdTC4w5O6+9/3x7g+FNqme7f3va8/72fMQBy7aGMJKLR+5+9M915q7H0TnFuRFzp+/QAMDA6ipqYGmaSxJEpgZRIR/lf61tUz+KqGTG1Pu73jV1ADgW3u8rbKpqUny+XyQZRmKopDX6wUzQ9NUMPOkg3pmdipfdTZ1H0/mguw41WK1sxBQXC6X1+12L6qqqkqPRCJio8dDn+3bB2aGoiiTQcx3cPGo++ncTIxkTpvNs2blqElJSZrJZNIBjApBQwA823d7cb/nRzFyxw9mhv6YMwGk0Om2lS3+33CB9BAyM7PI4XCISCQCg0GykpCcAqhZlhx4xuhI17vP7BRKaAQkJDDr/2R0+fIlenvTW3ihtDQbwO9ut5slg0F3ulyckZamA1CL81z8+XJ0+k9uyVMjo/jJWy6Fh/945Ewbf43R0OATjY2NMBgMHwLg+fOLlDVlq9lomcJ5TyVw9/cbVP++Jby/BDfaj23JGLvXi+sH1ono2PAEDKqqgpmlvr4+AHgnJyeH6+rq5OycfJ7+pJl/PbWKuaWcw1fWa1e3FfD+EjR2nNjyxNhQH657XyN59B6YGVJtbS2IiHw+Hw8Fg1pHR/uyn1tvOsyGsF7/5TrKTVRxvz+AGIpScvYMTdbVrLbjJzNS5sw7PW1ptdp6uFo4ZyxkMV6nYDBIz69Ydm3OvCXLHYM9R+tWmsTM9ERNgYMNFiuUUAQUCkpFS5/VMwpTXvnl+FZPjCkOM0vfRfuxzTQOwuLFizgwMERNFw7ebO698rphqP9Qw669kkwmNidmMcWaEQ2PwSAP04IXSyH/ebfWtzF3rdWVpue9vI2ImQEAmqZASDFQuz6RgiNGzTS1yObzFO6ZkmyvKKlYr1lESAoN9ICVMKwJLj0QjIpLR05EndPcq4rfO1c/AXpYLB1CSLh1dieZE6ayPWuuyVdd+LHF5awsLl+jWxCi0GAvkRqG2TVV770dEM2nvgs4p+e/NAEaF2tRkBSLu82HRVxyvj7c12K5fuD93UabVllSUckm/S+EB3uJ9Cgsqdl6Z8dt0Xa6oUU8PmKSYsG6hpSitbolaQY9GOwPFZRtqpZHw59ePPQFhcUUGJMyGQYzSJjIaneBBKVPcjThTNdAQoImj1GXbwdiLTa0Htvjsdpjty9cvcoYn+jU7vrbpatHv4mY4p0b/hP0KLiHeyIh/PW1bLTZufXIrjdsDqrLWlBs8Z89xca49OrnPvhh7/+DHsFABFV+gM76rWRxpPGNI5vLwsOhN+2piQdX7Ow6dOvcHvobtmklKOk4tvcAAAAASUVORK5CYII=), auto",
					},
					pathAttr: {
						'stroke-linecap': 'round',
						'stroke-linejoin': 'round'
					},
					path: {
						'stroke': 'yellow',
						'stroke-width': '12px',
						'opacity': '.5',
						'fill': 'none'
					}
				},
			}
		)
	);

	Toolkits.addToolkit({
		name: 'move',
		style: {
			base: {
				'cursor': 'grab',
				//'cursor': 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAArrAAAK6wGCiw1aAAAEI0lEQVQ4y1WUW2xUZRSF1/7/M3Pm0inTQm9AlQIlxYICWiMXLwRRJD5g9AEVqoQHDIK+8WCMiagJ+mA1BhLUBBNICka5GAGJKBRDFFFTEkkAhVLa0g4tQ2d65sw5579sHypEd7L3014r62HlAzPj9lprwNYIZhbMEXqO7knuW7NyhspdcMsjgxg42omokB//NwZs7R0tMTP+O2w0kXQ4d3KXyJ34Ykdt2/Jnhn451plpajvS/+3utrtWbTjY9NK75wE4YLbM1pKQ/xqxJZDg3I974/nurzekprY+dOvciULD8vb2useeTV/du5WDoevBtLWbkxc+3nIynmpeNmP9NgsouDWNBIAdMAMkxOj5i+bX1zYuWbyrY1umeWEqzPcyW2XY+qaiuZVSU1oScOOonDt//vCx4+t/27SAk7X1Z2e+uvNcZUsbCasjAJAy6SA2wZBIZBHL1iMza45RhWFio6RTMUGIdAIm8mFDlZr08LKOuR/u/IyqEp8Mn9rnAmAhYi68nj8VUYB5b3ec6juw/RQbH+7EOmEiX7BVYKvBOiISBBGLxzIt85JIJyCzmcbk5KZaAHB6Ojscv/en1eXBntlVc5bsCG70/VAeuLIiUdtI3uULZFQZJAVs4IGJQcJBrCKDKD8EXSjetDoaAwAx+NVbaxpWtO+e8+bnb1hT7HLSVUtLA38rt7qBZLoC1gRgtmAB2MCDKZVYZCoR3MyBg6jPcZKjAIToyyfyyZTrJ2pm8uRV7dOTdzU94fdfJuGmkZnZCsBAJJJITZ+FaDSPRH0jrGMxdvUS0lNbu+uffgVgC0EPrPvmyJaNW8PesxSvarQ1jzwprfKk8kbh1k+BNRFilVnIRAJORRaZe+8nf+S6iEbyoFB33+6f7Dx9Gi6i7uuHPppbdd/SluTUu0GCSLouSALWhGC2sFqBLaB8n72hPgp7r4w5wv1g0qLnhgGGIK1F8+otpYmLXnj9Rtf+v0ikqGLGbEtxglUBwAyrFUykof0QUWGMw2IBHKlLE7suDtxOJIQUFoCoXrCyZ+j4gcOm5IFJWGtCWDYwWkFHEXQQQgchguKoVcUCKH/zzITN7xUAEEAsCAQAJOPVYDXlYPHimZKIpR0GsdURTBjClBV0qKH8MoelWw6PDBYzNc175KLFACDGDxHYaJtoqEPT2pe7+vd/+p32CmA4rIIQqhxB+RFsoKD8MdalAkz/tWPVjz7/s0xXEhttQTTuRtJhZivqHl+H7D3L3s99/2XOKBaspAYLw1YZ5XsmKnusctcw6cEVh6oXrgLYCpIO34kFAETCEkFMe/Gds9r3t2uvAHJiBECSAylioYinSYpbY797Z3oPjyPH2Dv6//GImUDEXv+5yaX8+U2AlCby2aqytbakmcsua+zLuk/9kV3YRuNEIwDAP5EhS6j7lYH5AAAAAElFTkSuQmCC), auto',
			}
		},
		getBaseEl: function(){
			if(this.data.baseEl){
				return this.data.baseEl;
			}
			this.data.baseEl = this.grmCvs.elements.baseEl;
			return this.data.baseEl;
		},
		mousedown: function(event){
			if(this.data.drawing){
				return;
			}

			this.data.startPoint = this.getPoint(event);
			this.data.drawing = true;
		},
		mousemove: function(event){
			if(!this.data.drawing){
				return;
			}
			if(!this.data.startPoint){
				return;
			}

			var point = this.getPoint(event);
			
			var x = point.x - this.data.startPoint.x;
			var y = point.y - this.data.startPoint.y;
			// console.log('move 2:', event.type, point.x, point.y, this.data.startPoint.x, this.data.startPoint.y, x, y);

			this.data.startPoint = point;

			var matrix = this.grmCvs.canvasMatrix();
			// var zoom = matrix[0];

			//var move = this.grmCvs.move((matrix[4]+x)/zoom, (matrix[5]+y)/zoom);
			this.grmCvs.move((matrix[4]+x), (matrix[5]+y));
		},
		mouseup: function(event){
			if(!this.data.drawing){
				return;
			}

			this.data.drawing = false;
			this.data.startPoint = null;
		}
	});

	Toolkits.addToolkit({
		name: 'laserpointer',
		style: {
			base: {
				// 'cursor': "url(data:image/gif;base64,R0lGODlhAQABAIAAMQAAAP///ywAAAAAAQABAAACAkwBADs=), auto",
				// license
				// 'cursor': "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAK8AAACvABQqw0mAAAACB0RVh0U29mdHdhcmUATWFjcm9tZWRpYSBGaXJld29ya3MgTVi7kSokAAAEV0lEQVR4nMXUfWiVVRwH8O85z9t93ebdfXbnnb3tTjMVfMFIUoZmSSOWf1RkshaLKMyMVHQy3dVd3SyTCNT8J0SlILEUNGFJiG6BymhYQxTdfGkqbnjvvPd6d+/zcs7pj3lDRNHNZ/T96+Hh/Pjw/XE4RAiB/yPy/T8uvFkRJpKcJJoWI5K0jYCz8h/P9I4afHbRdN9TE8YTMHu1sK3LLB0PU5fvNUDMubp84Rcs0YfyPacGnIJp/iNFFF/36ZO/ql5vCsC7hMpBwflHRHX1GT1d+7mRmeIUCgBECIH2+ePGMyNbA83tLaDibT9hOmPMA0IYVV19UJQjYPYtonqOjj9w7rgTMAUA2eNLUVklsK358WQqmMzmPBIhAOcSzw3qYPYcUDkI4IYT6H+wdSe1ndvWRCIEoxDeAcNG0rQhUQoACjiXBLPDYFaNo7Bg7EsheLtgtkwJMSmARM5E0hjCBeecUNoBQg84Cks+X5wQOoe6PO1EUVMEEBKAhGHids6ABBEBlarALdVRmJvmda0ouFJY5gug8kGqeXokVetWKL2StIHbmayiQPT7np10wVG48vdeiyoqk1R1MwRnVNX+IFTpAbBb9fo7k0Juj8dvVWevnNt385sVPidgcv+T2TZvbJXg4iKAZRDie8hygTK2vDt79VxrIaxpxYHiE97Zb1SX1G9LOwo/LB0fvBJOdf91pJDY0wKB4qMFM+a+Fdyw685IYfroI0N5cc+xG94pM19NQjkdT8QXpDpPHLq5dVnBSOHHbpzPqZrKUObK2dZC2NMCgUCb/+Wqan3Nd6nhwo/dOJ9ZP7T1FT4/oyoJpTMeT1SmT7b+cim2ZNgXbtiN82lb9FLAutZzxE/YrHIXWlvnfb6jq6BivQv2wabP6loeNT/sxvlU/nQ64Y1MXYjBdFsXil6/5Akf5syeyUGa67fubHjU/Igb59O8akV1V1Y+5C4pQ6RUR19/Py51X8SkyZPrv1716ZZRgZc3f6v1DqTO2LY1UYGAW1HQf/MGnotUoKhoDNyaGo0uqd34oNkRr/puTDcVB10ShZHJ4O+OkxgTKEbomQjcpWGkcmYsun3X2gcNPvGqAeCdpas3XbvcszZQGoanZCzqIkWYnr6OPyfNxfHz/8AtkYaNyz7cfO/MkzYGAOzfsWVdWXlkg8vnh7ewCHp3J3pjLbhw7DCmTKiAabGWpp17NzgOA8DP27c0eV3apoHr19BRMRu/vf8JGvcdReLyeZSV6khlBtfHdu5tzJ93ZNX3ZvGKxqa0xaOzpk6G2d+LUHgc+rMc2WwOlBK4NXVddElts+MwALy3cn1jzjBiZSEdfbcGUOj3o6w0BNO2AQAuTWkYFRgAautjTbfTmahMCSAE9GAQJboO+y4+avAQvrExl8vFuBBgjEEPBhHSdTDG2KjCQ3isIWcYzZwL2LaNUEkJng6H6xy71Q/L3q+iLS5NW0MIMVVVzZhGbunajxfv/he+y+Uc8ssr8QAAAABJRU5ErkJggg==), auto",
				'cursor': "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAolBMVEUAAAD/AADmAADnAADmBAT/AADkBATmAwPlAwPlAgLmAwPqAADlAgLlAgLnAADkAADmAwPmAgLlAwPlAgLqAAD/AADjAwPlAADmAADlAgLjAADnAAD/AADmBATlAADlAgLjAADkAADlAgLlAgLjAADkBATlAgLkAADlAgLjBATkAADnAADlAADmAADmAADlAgLmAgLmAADlAgLlAgLlAgIAAAAHT4XHAAAANHRSTlMAAR4qSARCZcSeUwym7SscZtLMbBgDSjs0gSQVAkYn5C0T6/QuQfUv7EAwPzE+PfOEPOCHKi0m+AAAAAFiS0dEAIgFHUgAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfhCxwJMiXVdgAIAAAAfElEQVQoz83QxxKCQBAE0FnBhIAiSJJgJihLcP7/26j13Ht3rq+6unpILAxzSeBW683WQrCz2XER7A/e0Q8AnMIoTlIUORNlWOg/JA+wFMzlBcGVmW9IxF3JA8jzpaTSSY2k+UkL5K16HL18gHRakUo8NFT2zAP8zTh9aQb7ABBOyYCkvQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxNy0xMS0yOFQwOTo1MDozNyswMTowMA9cLbsAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTctMTEtMjhUMDk6NTA6MzcrMDE6MDB+AZUHAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg==), auto",
				// 'cursor': "default",
			},
			path: {
				'stroke': 'red'
			}
		},
		listeners: {
			contextmenu: function(){
				return false;
			}
		},
		reloadStyle: function(){
			if(this.data.pointer){
				this.data.pointer.stop.setAttribute('stop-color', this.style.path['stroke']);
			}
		},
		createPointerElement: function(container){
			var pointer = document.createElement('div');
			pointer.setAttribute('data-grm-laserpointer', '');

			var svg = SvgUtils.createElement('svg');
			svg.style.width = svg.style.height = '50px';
			var gradId = '_grm_laserpointer_redial_gradient_'+Date.now();
			svg.innerHTML = '<defs>'
						  + '<radialGradient id="'+gradId+'">'
						  + '<stop offset="0%" stop-color="'+this.style.path.stroke+'"></stop>'
						  + '<stop offset="100%" stop-color="transparent"></stop>'
						  + 'radialGradient>'
						  + '</defs>'
					  + '<rect x="10" y="10" rx="15" ry="15" fill="url(#'+gradId+')"></rect>';
			
			pointer.appendChild(svg);

			pointer.stop = pointer.querySelector('radialGradient > stop');

			var rect = pointer.rect = pointer.querySelector('rect');
			rect.setAttribute('width', 30);
			rect.setAttribute('height', 30);
			pointer.w = pointer.h = 24;

			(container || this.grmCvs.elements.baseEl)
			.appendChild( pointer );

			var pRect = pointer.getBoundingClientRect(),
				rRect = rect.getBoundingClientRect();

			Object.assign(pointer.style, {
				'position': 'absolute',
				'left': '-1000px',
				'top': '-1000px',
				'transform': 'translate('+(pRect.left - rRect.left)+'px, '+(pRect.top - rRect.top)+'}px)',
				// 'display': 'none',
			});

			return pointer;
		},
		preChange: function(){
			var pointer = this.data.pointer;
			if(!pointer){
				var pointer = this.data.pointer = this.createPointerElement();
				pointer.style.display = 'none';

				var rect = pointer.rect;
				rect.setAttribute('width', 16);
				rect.setAttribute('height', 16);
				pointer.w = pointer.h = 17;
			}
			this.grmCvs.elements.baseEl.setAttribute('data-canvas-point-only', '');
		},
		afterChange: function(){
			if(this.data.pointer){
				this.data.pointer.style.display = 'none';
			}
			this.grmCvs.elements.baseEl.removeAttribute('data-canvas-point-only');
		},
		mousedown: function(event){
			if(this.data.drawing){
				return;
			}
			
			this.data.drawing = true;
			
			var cvsData = Data[this.grmCvs.id];
			var matrix = this.grmCvs.canvasMatrix();
			this.data.tmpData = {
				cvsData: cvsData,
				baseRect: this.grmCvs.elements.baseEl.getBoundingClientRect(),
				canvasRect: this.grmCvs.elements.canvas.getBoundingClientRect(),
				matrix: matrix,
				ratio: cvsData.options.ratio,
				zoom: cvsData.options.zoom,
				ratioZoom: cvsData.options.ratio * cvsData.options.zoom,
				move: {
					x: this.grmCvs.getCenterPoint().x - matrix[4],
					y: this.grmCvs.getCenterPoint().y - matrix[5]
				}
			}
			
			var point = this.getOffsetPoint(event);

			var rect = this.data.pointer.rect;
			rect.setAttribute('width', 30);
			rect.setAttribute('height', 30);
			this.data.pointer.w = this.data.pointer.h = 24;

			var ratioZoom = this.data.tmpData.ratioZoom;
			var x = point.x, y = point.y;

			Data[this.grmCvs.id].GrmEvent.trigger('addPointer', {
				toolkit: this.name,
				id: this.grmCvs.id,
				x: x,
				y: y,
				color: this.style.path['stroke']
			});
			
			this.mousemove(event);
		},
		mousemove: function(event){
			if(!this.data.drawing){
				return;
			}

			// base. my pointer
			{
				var basePoint = this.getPoint(event, this.grmCvs.elements.baseEl, 1);
				basePoint.x -= this.data.pointer.w;
				basePoint.y -= this.data.pointer.h;
	
				this.data.pointer.style.display = 'block';
				this.data.pointer.style.left = basePoint.x + 'px';
				this.data.pointer.style.top = basePoint.y + 'px';
			}

			// ori point
			{
				var point = this.getOffsetPoint(event);
	
				var x = point.x, y = point.y;
	
				this.data.tmpData.cvsData.GrmEvent.trigger('movePointer', {
					toolkit: this.name,
					id: this.grmCvs.id,
					x: x,
					y: y,
					color: this.style.path['stroke']
				});
			}
		},
		mouseout: function(event){
			this.data.pointer.style.display = 'none';
		},
		mouseup: function(event){
			if(!this.data.drawing){
				return;
			}

			this.data.drawing = false;
			delete this.data.tmpData;
			
			this.data.pointer.style.display = 'none';
			var rect = this.data.pointer.rect;
			rect.setAttribute('width', 16);
			rect.setAttribute('height', 16);
			this.data.pointer.w = this.data.pointer.h = 16;

			this.mousemove(event);

			Data[this.grmCvs.id].GrmEvent.trigger('removePointer', {
				toolkit: this.name,
				id: this.grmCvs.id
			});
		}
	});

	var _toolkit_src_figure = Toolkits.addToolkit({
		name: 'figure',
		style: Object.assign({}, _toolkit_src_pencil.style),
		listeners: {
			contextmenu: function(){
				return false;
			}
		},
		setPointListByShiftKey: function(pointList, point, event){
			if(!event || !event.shiftKey){
				return;
			}
			var tX = point.x - pointList[0];
			var tY = point.y - pointList[1];
			var aX = Math.abs(tX);
			var aY = Math.abs(tY);

			if(aX > aY){
				if(tY > 0){
					point.y = pointList[1] + aX;
				}else{
					point.y = pointList[1] - aX;
				}
			}else{
				if(tX > 0){
					point.x = pointList[0] + aY;
				}else{
					point.x = pointList[0] - aY;
				}
			}
		},
		setPointListByAltKey: function(pointList, point, event){
			if(!event || !event.altKey){
				return;
			}
			var radiusX = (point.x - pointList[0]) * 1,
				radiusY = (point.y - pointList[1]) * 1
			;
			pointList[0] -= radiusX;
			pointList[1] -= radiusY;
		},
		setPointList: function(pointList, point, event){
			// shiftKey 가 먼저 수행 되어야 함
			this.setPointListByShiftKey(pointList, point, event);
			this.setPointListByAltKey(pointList, point, event);
			return pointList;
		},
		mousedown: function(e){
			if(this.data.drawing){
				return;
			}

			if(this.defaultMouseButton(event)){
				return;
			}

			this.data.drawing = true;

			var options = Data[this.grmCvs.id].options;
			this.data.tmpData = {
				options: options,
				ratioZoom: options.ratio * options.zoom
			};
			
			// var point = this.getOffsetPoint(event);
			var point = this.getPoint(e, null, this.data.tmpData.ratioZoom);
			this.data.pointList = [ point.x, point.y ];

			this.data.path = this.createElement(e);
			// this.data.g.appendChild(this.data.path);
			
			this.data.path.setAttribute('data-draw', '');

			for(var key in this.style.pathAttr){
				this.data.path.setAttributeNS(null, key, this.style.pathAttr[key]);
			}
			Object.assign(this.data.path.style, this.style.path);

			var zoom = this.grmCvs.zoom();
			if(zoom !== 1){
				var strokeWidth = parseFloat(this.data.path.style.strokeWidth);
				this.data.path.oriStrokeWidth = strokeWidth;
				// this.data.path.style.strokeWidth = (strokeWidth * zoom) + 'px';
				this.data.path.style.strokeWidth = (strokeWidth) + 'px';
			}

			this.grmCvs.elements.drawingCanvas.appendChild( this.data.path );
		},
		mousemove: function(e){
			if(!this.data.drawing){
				return;
			}

			// var point = this.getOffsetPoint(e);
			var point = this.getPoint(e, null, this.data.tmpData.ratioZoom);
			var list = this.setPointList(this.data.pointList.concat(), point, e);

			// render
			this.draw(list, this.data.path);
		},
		mouseup: function(e){
			// TODO
			_toolkit_src_pencil.mouseup.call(this, e);
		}
	});

	Toolkits.addToolkit(
		Object.assign(
			Object.clone(_toolkit_src_figure),
			{
				name: 'line',
				createElement: function(e){
					var el = SvgUtils.createElement('line');
					return el;
				},
				draw: Toolkits.toolkits.figure.drawLine,
				setPointList: function(pointList, point, event){
					if(event && event.shiftKey){
						var x = point.x - pointList[0];
						var y = point.y - pointList[1];
						var aX = Math.abs(x);
						var aY = Math.abs(y);
						
						var degree = Math.atan(aX/aY) * (180 / Math.PI);
						//var aDegree = Math.abs(degree);
						//if(aDegree > 30 && aDegree < 60){
						if(degree > 30 && degree < 60){
							//var aPX = Math.abs(point.x);
							//var aPY = Math.abs(point.y);
							var max = Math.max(aX, aY);
							var nX = pointList[0] + (max * (aX/x));
							var nY = pointList[1] + (max * (aY/y));
							pointList.push(nX);
							pointList.push(nY);
						}else{
							if(aX > aY){
								pointList.push(point.x);
								pointList.push(pointList[1]);
							}else{
								pointList.push(pointList[0]);
								pointList.push(point.y);
							}
						}
						
						if(event.altKey){
							var x = pointList[ pointList.length - 2 ];
							var y = pointList[ pointList.length - 1 ];
							pointList[0] -= (x - pointList[0]) - 1;
							pointList[1] -= (y - pointList[1]) - 1;
						}
					}else if(event && event.altKey){
						pointList[0] -= (point.x - pointList[0]) - 1;
						pointList[1] -= (point.y - pointList[1]) - 1;
						pointList.push(point.x);
						pointList.push(point.y);
					}else{
						pointList.push(point.x);
						pointList.push(point.y);
					}
					return pointList;
				}
			}
		)
	);
	
	Toolkits.addToolkit(
		Object.assign(
			Object.clone(_toolkit_src_figure),
			{
				name: 'triangle',
				createElement: function(e){
					var el = SvgUtils.createElement('polygon');
					return el;
				},
				draw: function(pointList, pathEl, options){
					pathEl.setAttributeNS(null, 'points', pointList.join(','));
				},
				oriSetPointList: Toolkits.toolkits.figure.setPointList,
				setPointList: function(pointList, point, event){
					if(event.shiftKey){ // 정삼각형, 회전
						var tX = (point.x - pointList[0]),
							tY = (pointList[1] - point.y);
						var r = Math.PI/180 * -60,
							sX = tX*(Math.cos(r)) - tY*(Math.sin(r)),
							sY = tX*(Math.sin(r)) + tY*(Math.cos(r))
							;
						pointList.push(point.x);
						pointList.push(point.y);
						pointList.push(sX + pointList[0]);
						pointList.push((-sY) + pointList[1]);

						if(event.altKey){
							// var v = Math.pow(Math.min(tX, tY), 2);
							// var hyp = Math.sqrt(v, v) / 2;
							
							var _y = pointList[3] - pointList[1];
							pointList[1] -= _y;
							pointList[2] += _y;
							pointList[4] -= _y;
						}
					}else{ // 이등변 삼각형, 비회전
						var x = pointList[0];
						var tX = Math.abs(x - point.x);
						pointList.push(x - tX);
						pointList.push(point.y);
						pointList.push(x + tX);
						pointList.push(point.y);
						
						if(event.altKey){
							var _y = pointList[3] - pointList[1];
							pointList[1] -= _y;
						}
					}

					return pointList;
				}
			}
		)
	);

	Toolkits.addToolkit(
		Object.assign(
			Object.clone(_toolkit_src_figure),
			{
				name: 'rectangle',
				createElement: function(e){
					var el = SvgUtils.createElement('rect');
					return el;
				},
				draw: function(pointList, pathEl, options){
					var x = pointList[0];
					var y = pointList[1];
					var width = pointList[2] - pointList[0];
					var height = pointList[5] - pointList[1];

					if(width < 0){
						x = pointList[4];
						width = Math.abs(width);
					}
					if(height < 0){
						y = pointList[5];
						height = Math.abs(height);
					}

					pathEl.setAttributeNS(null, 'x', x);
					pathEl.setAttributeNS(null, 'y', y);
					pathEl.setAttributeNS(null, 'width', width);
					pathEl.setAttributeNS(null, 'height', height);
				},
				oriSetPointList: Toolkits.toolkits.figure.setPointList,
				setPointList: function(pointList, point, event){
					this.oriSetPointList(pointList, point, event);
				
					var x = pointList[0];
					var y = pointList[1];
					var tX = point.x - x;
					var tY = point.y - y;
					
					x + tX;
					y + tY;
					
					pointList.push(x + tX);
					pointList.push(y);
					pointList.push(point.x);
					pointList.push(point.y);
					pointList.push(x);
					pointList.push(y + tY);
					pointList.push(x);
					pointList.push(y);
					
					return pointList;
				}
			}
		)
	);

	Toolkits.addToolkit(
		Object.assign(
			Object.clone(_toolkit_src_figure),
			{
				name: 'ellipse',
				createElement: function(e){
					var el = SvgUtils.createElement('ellipse');
					return el;
				},
				draw: function(points, pathEl, options){
					var radiusX = (points[2] - points[0]) * 0.5,
					radiusY = (points[3] - points[1]) * 0.5,
					centerX = points[0] + radiusX,
					centerY = points[1] + radiusY
					;

					if(radiusX < 0){
						radiusX = (points[0] - points[2]) * 0.5;
						centerX = points[2] + radiusX;
					}
					if(radiusY < 0){
						radiusY = (points[1] - points[3]) * 0.5;
						centerY = points[3] + radiusY;
					}

					pathEl.setAttributeNS(null, 'cx', centerX);
					pathEl.setAttributeNS(null, 'cy', centerY);
					pathEl.setAttributeNS(null, 'rx', radiusX);
					pathEl.setAttributeNS(null, 'ry', radiusY);
				},
				oriSetPointList: Toolkits.toolkits.figure.setPointList,
				setPointList: function(pointList, point, event){
					this.oriSetPointList(pointList, point, event);
					pointList.push(point.x);
					pointList.push(point.y);
					return pointList;
				}
			}
		)
	);

	Toolkits.addToolkit({
		name: 'textbox',
		style: {
			base: {
				'cursor': 'text'
			}
		},
		listeners: {
			contextmenu: function(){
				return false;
			},
			'grm-g-selected': function(e){
				// if(e.data && e.data.multiSelect){
				// 	return;
				// }
				this.setToolBox(e.target, true);
			},
			'grm-g-unselected': function(e){
				if(!e.target.hasAttribute('data-minimize')){
					var toolbox = e.target.querySelector('.editor-toolbox');
					if(toolbox){
						toolbox.remove();
					}
				}
			},
		},
		preChange: function(){
		},
		afterChange: function(){
		},
		minimize: function(el, minimize, publishEvent){
			var g = el.matches('[data-g]') ? el : el.closest('[data-g]');
			if(minimize){
				this.setToolBox(g, minimize);
				g.setAttribute('data-minimize', '');
				
				var els = g.querySelectorAll('[data-command="minimize"]');
				els.forEach(el => el.setAttribute('data-minimize', ''));
			}else{
				g.removeAttribute('data-minimize');

				var els = g.querySelectorAll('[data-command="minimize"]');
				els.forEach(el => el.removeAttribute('data-minimize'));

				g._trigger('grm-g-unselected');
			}

			if(publishEvent !== false){
				var cvsData = Data[this.grmCvs.id];
				cvsData.GrmEvent.trigger('minimizeElement', {
					did: g.getAttribute('data-did'),
					minimize: minimize
				});
			}
		},
		createTextBox: function(e){
			var point = this.getOffsetPoint(e);
			var g = this.grmCvs.createDrawElement();
			g.setAttribute('data-toolkit', this.name);
			Object.assign(g.style, {
				'left': point.x + 'px',
				'top': point.y + 'px',
				// 'width': '100px',
				// 'height': '100px',
			});

			g.addEventListener('click', e => {
				e.stopPropagation();
				clearTimeout(this.data._timer_blur);
			});

			var editor = g.ownerDocument.createElement('div');
			g.appendChild(editor);
			editor.classList.add('editor');
			editor.contentEditable = true;
			editor.tabIndex = -1;

			editor.addEventListener('selectstart', e => {
				e.stopPropagation();
			});
			editor.addEventListener('focus', e => {
				// console.log('# textbox focus', e.target);

				if(e.target._pre_html === undefined){
					console.log('# textbox save pre content');
					e.target._pre_html = e.target.innerHTML;
				}

				if(this.grmCvs.getToolkit() !== this){
					return;
				}
				if(!e.target.isContentEditable){
					return;
				}

				var g = e.target.closest('[data-g]');
				g.setAttribute('data-grm-edit', '');

				this.setToolBox(g);
			});
			
			editor.addEventListener('blur', e => {
				// console.log('# textbox blur', e.target);
				setTimeout(() => {
					clearTimeout(this.data._timer);
				}, 10);

				if(!e.target.isContentEditable){
					return;
				}

				var g = e.target.closest('[data-g]');
				g.removeAttribute('data-grm-edit');
				if(!e.target.innerHTML){
					g.remove();
					return;
				}

				clearTimeout(this.data._timer_blur);
				this.data._timer_blur = setTimeout(() => {
					// console.log('# textbox blur exec', e.target);

					e.target.contentEditable = false;
					try{
						if(!g.hasAttribute('data-minimize')){
							g.querySelector('.editor-toolbox').remove();
						}
					}catch(e){}
	
					var pre = e.target._pre_html;
					delete e.target._pre_html;
					if(pre == e.target.innerHTML){
						// console.log('# textbox add x', pre, e.target.innerHTML);
						return;
					}
					console.log('# textbox add');
	
					this.grmCvs.addDrawElements(g, {
						addJob: true,
						jobData: { el: g }
					});
				}, 200);
			});


			var checkQuery = (e) => {
				if(!editor.isContentEditable){
					return;
				}
				this.setToolBox(g).checkQuery();
			};
			editor.addEventListener('input', checkQuery);
			editor.addEventListener('keyup', checkQuery);
			editor.addEventListener('click', checkQuery);
			editor.addEventListener('keydown', e => {
				e.stopPropagation();
			});
			
			this.grmCvs.addDrawElements(g, {
				publishEvent: false
			});
			editor.focus();
		},
		setToolBox: function(g, minimizeOnly){
			var toolbox = g.querySelector('.editor-toolbox');
			if(g.querySelector('.editor-toolbox')){
				toolbox.checkQuery();
				return toolbox;
			}

			var document = this.grmCvs.elements.window.document;
			toolbox = document.createElement('div');
			g.appendChild(toolbox);

			toolbox.classList.add('editor-toolbox');
			var cmds = ['minimize'];
			var eventType = 'click'; //'mousedown';
			if(!minimizeOnly){
				var cmds_m = ['foreColor', 'backColor', 'fontSize', 'bold', 'underline', 'italic', 'strikeThrough'];
				cmds = cmds.concat(cmds_m);
				eventType = 'click';
			}
			cmds.forEach(type => {
				var command = document.createElement('button');
				command.setAttribute('data-command', type);
				command.innerHTML = '&nbsp;';
				toolbox.appendChild(command);
			});

			Events.addEventListener(toolbox, eventType, e => {
				if(!e.target.matches('[data-command]')){
					return;
				}

				var document = e.target.ownerDocument;
				var command = e.target.getAttribute('data-command');
				// console.log('# texteditor command :', command);
				switch(command){
				case 'minimize':
					var minimize = !g.hasAttribute('data-minimize');
					if(minimize){
						g._trigger('blur');
						toolbox.remove();
					}
					this.minimize(g, minimize);
					if(!minimize){
						g._trigger('grm-g-selected');
					}
					break;
				case 'foreColor':
				case 'backColor':
					var color = e.target.getAttribute('data-color');
					if(!color){
						if(this.setColorPicker(e.target)){
							var picker = e.target.closest('.editor-toolbox').querySelector('.editor-color-picker');
							if(picker) picker.remove();
						}
						return;
					}
					document.execCommand(command, false, color);
					
					var picker = e.target.closest('.editor-color-picker')
					if(picker) picker.remove();
					break;
				case 'fontSize':
					var size = e.target.getAttribute('data-size');
					if(!size){
						if(this.setFontSizePicker(e.target)){
							var picker = e.target.closest('.editor-toolbox').querySelector('.editor-font-size-picker');
							if(picker) picker.remove();
						}
						return;
					}
					document.execCommand(command, false, size);
					
					var picker = e.target.closest('.editor-font-size-picker')
					if(picker) picker.remove();
					break;
				default:
					document.execCommand(command, false, null);
					break;
				}

				g.querySelector('.editor').focus();
				toolbox.checkQuery();
			});

			toolbox.checkQuery = () => {
				//var g = e.target.closest('[data-g]');
				var editor = g.querySelector('.editor');
				if(!editor || !editor.isContentEditable){
					return;
				}

				// var toolbox = this.setToolBox(g);
				var toolbox = g.querySelector('.editor-toolbox');
				if(!toolbox){
					return;
				}

				var document = g.ownerDocument;

				[
					'foreColor', 'backColor', 'fontSize',
					'bold', 'underline', 'italic', 'strikeThrough'
				].forEach(cmd => {
					var btn = toolbox.querySelector(`[data-command="${cmd}"]`);
					if(!btn) return;

					var value = document.queryCommandValue(cmd);
					switch(cmd){
					case 'fontSize':
						try{
							var w = document.defaultView;
							// var cont = w.getSelection().getRangeAt(0).commonAncestorContainer;
							var cont = w.getSelection().getRangeAt(0).startContainer;
							var fontSize = w.getComputedStyle( cont.parentElement ).fontSize;
							btn.innerHTML = fontSize;
						}catch(e){
							console.error(e);
						}
						break;
					case 'foreColor':
					case 'backColor':
						btn.style.backgroundColor = value;
						break;
					default:
						btn.setAttribute('data-selected', value);
						break;
					}
				});
			};
			
			return toolbox;
		},
		setFontSizePicker: function(el){
			var document = this.grmCvs.elements.window.document;
			var toolbox = el.closest('.editor-toolbox');
			if(toolbox.querySelector('.editor-color-picker')){
				return true;
			}

			var picker = document.createElement('ol');
			picker.classList.add('editor-font-size-picker');
			toolbox.appendChild(picker);

			['10px', '13px', '16px', '18px', '24px', '32px', '48px'].forEach((size, i) => {
				var li = document.createElement('li');
				li.setAttribute('data-command', 'fontSize');
				li.setAttribute('data-size', i+1);
				li.innerHTML = size;
				picker.appendChild(li);
			});

			Object.assign(picker.style, {
				left: el.offsetLeft + 'px',
				top: (el.offsetTop + el.offsetHeight) + 'px',
			});
		},
		setColorPicker: function(el){
			var document = this.grmCvs.elements.window.document;
			var toolbox = el.closest('.editor-toolbox');
			if(toolbox.querySelector('.editor-color-picker')){
				return true;
			}
			
			var command = el.getAttribute('data-command');
			var picker = document.createElement('div');
			picker.classList.add('editor-color-picker');
			toolbox.appendChild(picker);

			picker.focus();

			function createBtn(color, i){
				var btn = document.createElement('div');
				btn.setAttribute('data-command', command || 'foreColor');
				btn.setAttribute('data-color', color);

				Object.assign(btn.style, {
					backgroundColor: color
				});
				picker.appendChild(btn);
			}
			if(command === 'backColor'){
				createBtn('transparent');
			}
			[
			'000000', '7F7F7F', '880015', 'ED1C24', 'FF7F27', 'FFF200', '22B14C', '00A2E8', '3F48CC', 'A349A4',
			'FFFFFF', 'C3C3C3', 'B97A57', 'FFAEC9', 'FFC90E', 'EFE4B0', 'B5E61D', '99D9EA', '7092BE', 'C8BFE7'
			].forEach(c => {
				createBtn('#' + c);
			});

			// makeColorGradient(
			// 	.3, .3, .3,
			// 	0, 5, 10,
			// 	128, 127, 20,
			// 	createBtn
			// );

			Object.assign(picker.style, {
				left: el.offsetLeft + 'px',
				top: (el.offsetTop + el.offsetHeight) + 'px',
			});

			function RGB2Color(r, g, b) {
				return '#' + byte2Hex(r) + byte2Hex(g) + byte2Hex(b);
			}
			function byte2Hex(n) {
				var nybHexString = "0123456789ABCDEF";
				return String(nybHexString.substr((n >> 4) & 0x0F, 1)) + nybHexString.substr(n & 0x0F, 1);
			}
			function roundDecimal(v, n) {
				var isNeg = v < 0;
				v = Math.abs(v);

				return (isNeg ? '-' : '') + String(Math.floor(v)) + '.' + String((1 + Math.abs(v) - Math.floor(Math.abs(v))) * Math.pow(10, n)).substr(1, n);
			}
			function colorText(str, phase) {
				if (phase == undefined)
					phase = 0;
				center = 128;
				width = 127;
				frequency = Math.PI * 2 / str.length;
				for (var i = 0; i < str.length; ++i) {
					red = Math.sin(frequency * i + 2 + phase) * width + center;
					green = Math.sin(frequency * i + 0 + phase) * width + center;
					blue = Math.sin(frequency * i + 4 + phase) * width + center;
					document.write('<font style="color:' + RGB2Color(red, green, blue) + '">' + str.substr(i, 1) + '</font>');
				}
			}
			function makeColorGradient(
				frequency1, frequency2, frequency3,
				phase1, phase2, phase3,
				center, width, len,
				callback
			) {
				if (len == undefined)
					len = 50;
				if (center == undefined)
					center = 128;
				if (width == undefined)
					width = 127;

				for (var i = 0; i < len; ++i) {
					var red = Math.sin(frequency1 * i + phase1) * width + center;
					var grn = Math.sin(frequency2 * i + phase2) * width + center;
					var blu = Math.sin(frequency3 * i + phase3) * width + center;
					if(callback){
						callback( RGB2Color(red, grn, blu), i );
					}
				}
			}
		},
		mousedown: function(e){
			var g = e.target.closest(`[data-g][data-toolkit="${this.name}"]`);
			if(g){
				var isEditorContents = e.target.matches(`[data-g][data-toolkit="${this.name}"] .editor *`);
				if(isEditorContents){
					this.dblclick(e);
				}else{
					//
				}
				return;
			}

			clearTimeout(this.data._timer);
			this.data._timer = setTimeout(() => {
				this.createTextBox(e);
			}, 200);
		},
		dblclick: function(e){
			// console.log('dblclick', e);
			clearTimeout(this.data._timer);
			var g = e.target.closest(`[data-g][data-toolkit="${this.name}"]`);
			if(!g){
				return;
			}
			
			var editor = g.querySelector('.editor');
			if(editor.ownerDocument.activeElement === editor){
				//return;
			}else{
				// console.log('# textbox : edit', editor);
			}

			this.minimize(g, false, true);
			
			editor.contentEditable = true;
			this.setToolBox(g);
			editor.focus();
		},
		mousemove: function(event){
		},
		mouseout: function(event){
		},
		mouseup: function(event){
		}
	});
	// -- Toolkit E ---------------------------------------------

	// -- Link S ---------------------------------------------
	var LinkElement = function(link){

	}
	// -- Link E ---------------------------------------------


	// -- GrmEvent S ------------------------------------------------------------------------------------------------------
	var GrmEvent = function(target){
		this.objEventMap = new Map();
		this.target = target;
	}
	GrmEvent.prototype = {
		trigger: function(eventName, data){
			var eventMap = this.objEventMap.get(this.target);
			if(!eventMap){
				return;
			}
			
			var eventList = eventMap.get(eventName);
			if(!eventList){
				return;
			}
			
			var event = {
				type: eventName,
				target: this.target,
				data: data
			};
			
			for(var i=0, len=eventList.length; i<len; i++){
				var func = eventList[i];
				func.func.call(this.target, event);
				if(event.stopPropagation){
					break;
				}

				if(func.desc && func.desc.once === true){
					eventList.splice(i, 1);
					len--;
					i--;
				}
			}
		},
		setOnOffEvents: function(obj){
			obj = obj || this.target;
			var eventMap = this.objEventMap.get(obj);
			if(!eventMap){
				eventMap = new Map();
				this.objEventMap.set(obj, eventMap);
			}
			
			Object.defineProperties(obj, {
				'on': {
					writable: false,
					value: function(eventName, func, desc){
						if(!eventName || !func){
							return this;
						}

						eventName.split(' ').forEach(function(eventName){
							if(!eventName || eventName === ' ') return;
							var eventList = eventMap.get(eventName);
							if(!eventList){
								eventList = [];
								eventMap.set(eventName, eventList);
							}
							eventList.push({
								func: func,
								desc: desc
							});
						});
						
						return this;
					}
				},
				'off': {
					writable: false,
					value: function(eventName, func){
						if(arguments.length === 0){
							eventMap.clear();
							return this;
						}
						
						if(func){
							var eventList = eventMap.get(eventName);
							if(!eventList){
								return this;
							}
							
							for(var i=0; i<eventList.length; i++){
								if(eventList[i].func===func){
									eventList.splice(i, 1);
									break;
								}
							}
						}else{
							eventMap.delete(eventName);
						}
						return this;
					}
				}
			});
		}
	}
	// -- GrmEvent E ------------------------------------------------------------------------------------------------------
	
	var SvgUtils = {
		createElement: function(type){
			return document.createElementNS('http://www.w3.org/2000/svg', type);
		},
		setAttributeNS: function(el, namespace, name, value){
			var ns = 'http://www.w3.org/1999/';
			el.setAttributeNS(ns + namespace, name, value);
		},
		getTransform: function(el, type){
			if(!el) return null;
			if(el instanceof SVGElement !== true){
				// TODO
				var draw = el.querySelector('[data-draw]');
				if(draw){
					el = draw;
				}else{
					throw 'el is not SVGElement : ' + el;
				}
			}

			type = type.toLowerCase();
			var scale, translate;
			for(var j=0; j<el.transform.baseVal.length; j++){
				var item = el.transform.baseVal.getItem(j);
				switch(item.type){
				case SVGTransform.SVG_TRANSFORM_SCALE:
					scale = item;
					break;
				case SVGTransform.SVG_TRANSFORM_TRANSLATE:
					translate = item;
					break;
				}
			}
			if(!scale){
				scale = el.ownerSVGElement.createSVGTransform();
				scale.setScale(1, 1);
				el.transform.baseVal.appendItem(scale);
			}
			if(!translate){
				translate = el.ownerSVGElement.createSVGTransform();
				translate.setTranslate(0, 0);
				el.transform.baseVal.appendItem(translate);
			}

			switch(type){
			case 'scale': return scale;
			case 'translate': return translate;
			}
			return null;
		}
	}

	var Utils = {
		data: {
			_id: 0
		},
		createId: function(){
			// var dt;
			// try{
			// 	dt = Date.now();
			// }catch(e){
			// 	dt = (new Date()).getTime();
			// }
			
			// return 'grm_cvs_' + dt + '_' + this.data._id++;
			return this.generateUID();
		},
		getPoint: function(event, baseEl){
			var x, y;
			var list;
			if(
				event.type.indexOf('mouse')===0
				|| event.pointerType === 'mouse'
				|| event.type.indexOf('wheel')===0
				|| event.type.indexOf('contextmenu')===0
			){
				if(baseEl){
					var rect = baseEl.getBoundingClientRect();
					x = event.clientX - rect.left;
					y = event.clientY - rect.top;
				}else{
					// x = typeof event.offsetX !== 'undefined' ? parseInt(event.offsetX) : parseInt(event.layerX);
					// y = typeof event.offsetY !== 'undefined' ? parseInt(event.offsetY) : parseInt(event.layerY);
					x = event.clientX;
					y = event.clientY;
				}
			}else{
				// touch
				event = event.originalEvent || event;
				var touches = event.changedTouches || event.pointers;//event.touches;
				
				var rect = (baseEl && baseEl.getBoundingClientRect()) || {left: 0, top: 0};
				
				if(touches){
					list = [];
					for(var i=0, len=touches.length; i<len; i++){
						var px = touches[i].pageX - rect.left + document.body.scrollLeft;
						var py = touches[i].pageY - rect.top + document.body.scrollTop;
	//					var px = touches[i].clientX;
	//					var py = touches[i].clientY;
						
						if(i==0){
							x = px;
							y = py;
						}
						list.push( {x:px, y:py} );
					}
				}else{
					x = event.pageX - rect.left + document.body.scrollLeft;
					y = event.pageY - rect.top + document.body.scrollTop;
				}
			}
			return {x:x, y:y, list: list};
		},
		getOffsetPoint: function(e){
			if(e.offsetX !== undefined){
				return {
					x: e.offsetX,
					y: e.offsetY
				};
			}else if(e.touches){
				var rect = e.path[0].getBoundingClientRect();
				var ratio = e.path[0].clientWidth / rect.width;
				return {
					x: (e.touches[0].pageX - rect.left) * ratio,
					y: (e.touches[0].pageY - rect.top) * ratio,
				}
			}
		},
		generateUID: function(){
			var comp = 3;
			var uid = '';
			for(var i=0; i<comp; i++){
				var t = (Math.random() * 46656) | 0;
				uid += ('000' + t.toString(36)).slice(-3);
			}
			return uid;
		}
	}

	var GrmYouTube = {
		data: {},
		PlayerState: null,
		init: function(){
			var THIS = this;

			switch(THIS.data.ready){
			case 'ready':
				return Promise.resolve();
				break;
			case 'load':
				// TODO
				break;
			case 'error':
				break;
			}

			THIS.data.ready = 'load';

			return new Promise(function(resolve, reject){
				var tag = document.createElement('script');
				tag.src = "https://www.youtube.com/player_api";
				var firstScriptTag = document.getElementsByTagName('script')[0];
				firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
				tag.onload = function(){
					YT.ready(function(){
						THIS.data.ready = 'ready';
						THIS.PlayerState = YT.PlayerState;
						resolve();
					});
				}
				tag.onerror = function(e){
					THIS.data.ready = 'error';
					reject(e);
				}
			});
		},
		createPlayer: function(element, youtubeUrlStr, options){
			var videoId = (function(str){
				if(!str) return null;

				if(str.indexOf('youtube.com') > -1){
					var idx = str.indexOf('?');
					if(idx === -1) return null;

					str = str.substring(idx + 1);
					var st = str.indexOf('v=');

					if(st === -1) return null;
					var ed = str.indexOf('&', st);
					if(ed === -1){
						return str.substring(st + 2);
					}
					return str.substring(st + 2, ed);
				}
				else if(str.indexOf('youtu.be') > -1){
					// https://youtu.be/jSqHotawH2M
					str = str.substring(str.lastIndexOf('/') + 1);
					var idx = str.indexOf('?');
					if(idx > -1){
						return str.substring(0, idx);
					}
					return str;
				}

			}(youtubeUrlStr));

			if(!videoId){
				return Promise.reject('invalid youtube videoId : ' + youtubeUrlStr);
			}

			if(!options){
				options = {};
			}
			Object.assign({
				width: '320',
				height: '180'
			}, options);

			return new Promise(function(resolve, reject){
				var player = new YT.Player(element, {
					videoId: videoId,// 'V2hlQkVJZhE',
					width: options.width,
					height: options.height,
					// playerVars: {
					// 	controls: '2'
					// },
					events: {
						'onReady': function(e){
							resolve(player);
						},
						'onStateChange': options.onStateChange, /*function(e){
							switch(e.data){
							case YT.PlayerState.BUFFERING: // 3
								break;
							case YT.PlayerState.CUED: // 5 : play ready
								break;
							case YT.PlayerState.PLAYING: // 1
								break;
							case YT.PlayerState.PAUSED: // 2
								break;
							case YT.PlayerState.ENDED: // 0
								break;
							case -1: // error?
								break;
							default:
								console.warn('[YT] unknown state :', e.data);
								break;
							}
						}*/
					}
				});
			});
		}
	}

	var GrmCvsStyle = {
		generate: function(){
			var query = 'style[data-grmcvs-style]';
			var style = document.querySelector(query);
			if(style){
				return;
			}

			var listeners = {};
			function mouseListener(e){
				var listener = listeners[e.type];
				if(!listener) return;
				listener.forEach(function(listener){
					listener(e);
				});
			}
			['mouseover', 'mouseout'].forEach(function(type){
				listeners[type] = [];
				document.body.addEventListener(type, mouseListener);
			});

			var css = {
				'[data-grm-cvs="box"]': GrmCvsCssObj,
				'[data-grm-cvs="ctx-menu"]': {
					'display': 'none',
					'position': 'absolute',
					'z-index': '9999',
					'min-width': '150px',
					'background-color': '#fff',
					'border': '1px solid #ccc',
					'border-radius': '3px',
					'outline': 'none',
					'[data-grm-ctx-item]': Object.assign({
						'padding': '5px 10px',
						// 'border-bottom': '1px solid #ccc',
						'cursor': 'pointer',
						'&:hover': {
							'background-color': '#F1F1F1'
						},
						'&:active': {
							'background-color': '#e0e0e0'
						},
						'&.uline': {
							'font-size': '0px',
							'padding': '0px',
							'border-bottom': '1px solid #ccc',
						},
						'&:last-child': {
							'border-bottom': 'none',
						},
						'&[data-grm-ctx-item-type^="arrange."]': {
							'display': 'none'
						},
					}, (function(){
						var data = {};
						['copy', 'copy_paste', 'remove'].forEach(function(type){
							data['&[data-grm-ctx-item-type="'+type+'"]'] = {
								'display': 'none'
							}
						});
						return data;
					}())),
					'&[data-ctx-type="element"]': {
						'[data-grm-ctx-item]': Object.assign({
							'&[data-grm-ctx-item-type="paste"]': {
								'display': 'none'
							},
							'&[data-grm-ctx-item-type^="arrange."]': {
								'display': 'block'
							},
						}, (function(){
							var data = {};
							['copy', 'copy_paste', 'remove'].forEach(function(type){
								data['&[data-grm-ctx-item-type="'+type+'"]'] = {
									'display': 'block'
								}
							});
							return data;
						}()))
					}
				},
			};
			var arr = parse('', css, []);
			style = document.createElement('style');
			style.setAttribute('data-grmcvs-style', '');
			style.setAttribute('type', 'text/css');
			style.textContent = arr.join('\r\n');
			document.head.appendChild( style );

			function parse(key, css, arr){
				var start = false;
				for(var i in css){
					var value = css[i];
					if(typeof value === 'object'){
						if(start){
							start = false;
							arr.push('}');
						}

						var nextKey;
						i.split(',').forEach(function(i, idx, arr){
							i = i.trim();
							if(!i) return;

							var str = key;
							if(i.indexOf('&') === 0){
								str += i.substring(1);
							}else{
								str += ' ' + i;
							}
							if(idx === 0){
								nextKey = str;
							}else{
								nextKey += ', ' + str;
							}
						});
						parse(nextKey, value, arr, false);
					}else if(typeof value === 'function'){
						listeners[i].push((function(selector, listener){
							return function(e){
								if(!e.target.matches(selector)){
									return;
								}
								listener(e);
							};
						}(key, value)));
					}else{
						if(!start){
							start = true;
							arr.push(key + '{');
						}
						var value = css[i];
						if(value === '') value = '\'\'';
						else if(i === 'content'){
							value = '\'' + value + '\'';
						}
						arr.push(' ' +i+': '+value+';');
					}
				}
				if(start){
					arr.push('}');
				}
				return arr;
			}
		},
		variables: {
			'data-g-selected': {
				'outline': '1px dashed #0cf',
				'[data-type="rotate-dot"]': (function(){
					var width = 20;
					var data = {
						'position': 'absolute',
						'width': width+'px',
						'height': width+'px',
						// 'background-color': 'rgba(0, 204, 255, 0.8)', //'#0cf',
						// 'border': 'solid 2px #0cf',
						//'border-radius': '50%'
					};
					
					var cursor = 'url(data:image/png;base64,AAABAAEAEBAAAAEAIABoBAAAFgAAACgAAAAQAAAAIAAAAAEAIAAAAAAAAAQAABMLAAATCwAAAAAAAAAAAACNjY0AjY2NAI2NjQCNjY0JjIyMH4eHhzOEhIRHg4ODVYKCglaDg4NPh4eHQYuLiyOMjIwIjY2NAI2NjQCNjY0AjY2NAI6OjgCMjIwKiYmJJYGBgVWBgYGIfX19m3p6epqBgYGUhISEf4GBgWOCgoJYiIiIM4yMjAyNjY0AjY2NAI2NjQCMjIwDkJCQKoSEhIV0dHS7m5ub8Kenp/+oqKj/qKio/YaGhtV3d3egiIiId4CAgF2IiIg0jIyMCI2NjQCMjIwAi4uLIImJiaKOjo74uLi4/97e3v/j4+P/5OTk/+Tk5P/CwsL/lJSU/4qKisyIiIiBgYGBVIuLiyONjY0CkZGRCZSUlH+Li4v/1tbW/+Hh4f+ioqL/n5+f/6urq/+ioqL/zs7O/+Hh4f+cnJz/iYmJyYiIiHSGhoY+jY2NC4uLiyWSkpLv0tLS/8vLy/+Tk5P/hISEfYCAgEKIiIhAhISEWZaWluizs7P/39/f/5aWlvt6enqZhISESoqKihiBgYFspaWl/93d3f+enp7+h4eHj4+PjwGNjY0AjIyMAIuLiweNjY1cmJiY6NDQ0P+/v7//iYmJ1IWFhWmIiIgfn5+fyMvLy//CwsL/dXV1zYiIiDuNjY0AjY2NAIyMjBOJiYlJh4eHOn9/f3upqan/4eHh/6SkpPqDg4N6iIiIHaKiotrZ2dn/w8PD/3d3d7+EhIRAjIyMFI2NjQGMjIxlg4ODvICAgFuBgYGIqKio/+Pj4/+fn5//fX19dYqKihKkpKTa19fX/8HBwf9zc3PAgYGBV4iIiDSOjo4Li4uLznFxcft+fn6Jenp6kqenp//n5+f/oaGh/4GBgWONjY0Fl5eXq8LCwv/Jycn/fn5+3YGBgXeFhYU3hISENn5+fuvBwcH/f39/5Xl5ebexsbH/29vb/6Ojo/SMjIxEjIyMAH19fUCdnZ3/4uLi/6+vr/+Ojo7Kj4+PM4SEhJmzs7P84eHh/56env+Pj4//4eHh/6urq/+BgYGhkJCQE4yMjACCgoIHgYGBurq6uv+5ubn/hYWFvI+PjyJ+fn7N0NDQ/+jo6P/a2tr/z8/P/8zMzP+GhobxhISEV4yMjACNjY0Ag4ODAIWFhTCKiorwgYGB3oODgyaWlpZTmpqa9Nvb2//k5OT/6urq/9ra2v+Wlpb/iIiIrIuLi0CMjIwQjY2NAIKCggCMjIwAiIiILW1tbSaMjIwAiYmJp8PDw//l5eX/5OTk/+Xl5f/h4eH/nZ2d/3Nzc5eJiYkijY2ND42NjQCCgoIAjIyMAImJiQB1dXUAjo6OAIGBga6MjIzziYmJ8pGRkfKRkZHylpaW8n19ffOCgoLhlZWVO4yMjAGNjY0A4AcAAMADAACAAQAAgAAAAAAAAAAAAAAAAwAAAAYAAAAAAAAAAAAAAAABAAAAAQAAAAMAAIABAADIAQAA+AEAAA==), auto';
					data['&[data-rotate-type]'] = {cursor: cursor};

					for(var i=0, df=(width/-2-1.5-10)+'px'; i<4; i++){
						var p = null;
						switch(i){
						case 0:
							p = {left: df, top: df};
							break;
						case 1:
							p = {right: df, top: df};
							break;
						case 2:
							p = {left: df, bottom: df};
							break;
						case 3:
							p = {right: df, bottom: df};
							break;
						}

						data['&[data-rotate-type="'+i+'"]'] = p;
					}
					return data;
				}()),
				'[data-type="resize-dot"]': (function(){
					var width = 20;
					var data = {
						'position': 'absolute',
						'width': width+'px',
						'height': width+'px',
						'background-color': 'rgba(0, 204, 255, 0.8)', //'#0cf',
						'border': 'solid 2px #0cf',
						//'border-radius': '50%'
					};
					for(var i=0, df=(width/-2-1.5)+'px'; i<8; i++){
						var p = null;
						switch(i){
						case 0:
							p = {left: df, top: df, cursor: 'nw-resize'};
							break;
						case 1:
							p = {left: 'calc(50% + '+df+')', top: df, cursor: 'n-resize'};
							break;
						case 2:
							p = {right: df, top: df, cursor: 'ne-resize'};
							break;
						case 3:
							p = {left: df, top: 'calc(50% + '+df+')', cursor: 'e-resize'};
							break;
						case 4:
							p = {right: df, top: 'calc(50% + '+df+')', cursor: 'e-resize'};
							break;
						case 5:
							p = {left: df, bottom: df, cursor: 'ne-resize'};
							break;
						case 6:
							p = {left: 'calc(50% + '+df+')', bottom: df, cursor: 'n-resize'};
							break;
						case 7:
							p = {right: df, bottom: df, cursor: 'nw-resize'};
							break;
						}

						data['&[data-resize-type="'+i+'"]'] = p;
					}
					return data;
				}()),
			}
		}
	}
	var GrmCvsCssObj = {
		'position': 'relative',
		'width': '100%',
		'height': '100%',
		'text-align': 'initial',
		'outline': 'none',
		'font-size': '13px',

		'a': (function(){
			var data = {};
			['link', 'visited', 'active', 'hover'].forEach(function(t){
				data['&:'+t] = {
					'color': '#848484'
				}
			});
			return data;
		}()),
		'[data-grm-cvs="wrapper"]': {
			'position': 'relative',
			'margin': 'auto',
			'overflow': 'hidden',
			'width': '100%',
			'height': '100%',
		},
		'[data-grm-cvs="base"]': {
			'position': 'absolute',
			// 'left': '50%',
			// 'top': '50%',
			// 'transform': 'translate(-50%, -50%)',
			'width': '100%',
			'height': '100%',
			'overflow': 'hidden',
			'&[data-toolkit-name="select"]': {
				'[data-g]': {
					// '&:has(> svg:hover)': GrmCvsStyle.variables['data-g-selected']
					// '&:hover': GrmCvsStyle.variables['data-g-selected']
					'[data-draw]': {
						'mouseover': function(e){
							var g = e.target.closest('[data-g]');
							g.style.pointerEvents = '';
							if(g.hasAttribute('data-grm-selected')){
								return;
							}
							g.setAttribute('data-hover', '');
						},
						'mouseout': function(e){
							var g = e.target.closest('[data-g]');
							g.removeAttribute('data-hover');
							if(!g.hasAttribute('data-grm-selected')){
								g.style.pointerEvents = '';
							}else{

							}
						}
					},
					'&[data-hover]': Object.assign({},
						GrmCvsStyle.variables['data-g-selected'],
						{
							'cursor': 'move',
							'[data-draw]': {
								// 'pointer-events': 'none'
							}
						}
					),
					'&[data-toolkit="link"]': {
						'pointer-events': 'inherit',
						// 'background-color': 'rgba(255, 255, 255, 0.9)',
						'&:hover': Object.assign({},
							GrmCvsStyle.variables['data-g-selected'],
							{
								'cursor': 'move'
							}
						)
					},
				},
				'&[data-drag-select-mode]': {
					'[data-g]': {
						'&:hover': {
							'[data-type="resize-dot"]': {
								'display': 'none'
							}
						}
					}
				}
			},
			'&[data-canvas-point-only]': {
				'[data-grm-cvs="canvas"] *': {
					'pointer-events': 'none !important'
				}
			},
		},
		'[data-grm-cvs="canvas"]': {
			'position': 'absolute',
			'left': '0',
			'top': '0',
			'width': '100%',
			'height': '100%',
			'font-size': '13px',
			// 'overflow': 'hidden'
		},
		'[data-grm-cvs="drawing-canvas"]': {
			'position': 'absolute',
			'left': '0',
			'top': '0',
			'width': '100%',
			'height': '100%',
			'background-color': 'transparent',
			'pointer-events': 'none'
		},
		'[data-g]': {
			'position': 'absolute',
			'pointer-events': 'none',
			'box-sizing': 'border-box',
			'font-size': '0',
			'&:not([data-grm-selected])': {
				'transition': '0.1s',
				'[data-draw]': {
					'transition': '0.1s'
				}
			},
			'&[data-grm-selected]': Object.assign(
				{},
				GrmCvsStyle.variables['data-g-selected'],
				{
					'cursor': 'move',
					'background-color': 'rgba(0, 204, 255, 0.2)',
					'pointer-events': 'auto',
				}
			),
			'&[data-grm-drag-intersection]': Object.assign(
				{},
				GrmCvsStyle.variables['data-g-selected'],
				{
					// 'outline-style': 'dashed',
					'background-color': 'rgba(0, 204, 255, 0.05)',
					'[data-type="resize-dot"]': {
						'display': 'none'
					}
				}
			),
			'> svg': {
				'overflow': 'visible',
				'width': '100%',
				'height': '100%',
				'pointer-events': 'none',
				'&:has(> path)': {
					'border': '1px solid red'
				}
			},
			'[data-draw]': {
				'pointer-events': 'auto',
			},
			'.grm-g-wrapper': {
				'width': '100%',
				'height': '100%',
				'overflow': 'hidden'
			}
		},
		// textbox
		'[data-g][data-toolkit="textbox"]': {
			// 'overflow': 'hidden',
			'&[data-grm-edit]': {
				'background-color': 'transparent'
			},
			'.editor': {
				'width': '100%',
				'height': '100%',
				'min-width': '100px',
				'min-height': '50px',
				'word-break': 'break-all',
				'pointer-events': 'auto',
				'font-size': '13px',
				
				'&:focus': {
					'border': '1px solid #0cf',
					'background-color': 'rgba(206, 206, 206, 0.3)'
				}
			},
			'&[data-minimize]': {
				'outline': 'none',
				'background-color': 'transparent',
				'opacity': '.8',
				'> :not(.editor, .editor-toolbox)': {
					'display': 'none'
				},
				'[data-type="resize-dot"]': {
					'display': 'none'
				},
				'.editor': {
					'min-width': '50px',
					width: '50px',
					height: '50px',
					'background-color': '#0cf',
					overflow: 'hidden',
					opacity: '.5',
					position: 'absolute',
					left: '0px',
					top: '0px',
				},
				'.editor-toolbox': {
					'top': '0'
				}
			},
			'.editor-toolbox': {
				'position': 'absolute',
				'left': '0px',
				'top': '-30px',
				'width': 'max-content',
				'pointer-events': 'auto',
				'font-size': '12px',

				'[data-command]': {
					'width': '30px',
					'height': '30px',
					'box-sizing': 'border-box',
					'border': '1px solid #8e8e8e',
					'background-color': '#eee',
					'outline': 'none',
					//'background-color':' #f1f1f1',
					'padding': '0px',
					'font-size': '1em',
					'cursor': 'pointer',

					'&:before': {
						'width': '100%',
						'height': '100%',
					},
					'&[data-selected="true"]': {
						'background-color': '#666',
						'color': '#fff'
					}
				},
				'[data-command="minimize"]': {
					'&:before': {
						'content': '↙'
					},
					'&[data-minimize]': {
						'&:before': {
							'content': '↗'
						},
					}
				},
				'[data-command="foreColor"], [data-command="backColor"]': {
					'background-color': '#000',
					'&:before': {
						'content': ' '
					}
				},
				'[data-command="bold"]': {
					'font-weight': 'bold',
					'&:before': {
						'content': 'B'
					}
				},
				'[data-command="underline"]': {
					'text-decoration': 'underline',
					'&:before': {
						'content': 'U'
					}
				},
				'[data-command="italic"]': {
					'font-style': 'italic',
					'&:before': {
						'content': 'I'
					}
				},
				'[data-command="strikeThrough"]': {
					'text-decoration': 'line-through',
					'&:before': {
						'content': 'S'
					}
				},
				'.editor-font-size-picker': {
					'position': 'absolute',
					'line-height': '90%',
					'list-style': 'none',
					'padding': '0',
					'margin': '0',

					'[data-command][data-size]': {
						// display: 'inline',
						// width: '20px',
						// height: '20px',
						'border': '1px solid #000',
						'cursor': 'pointer',
						'background-color': '#fff',
						'width': '50px',
						'height': '20px',
						'padding-top': '2px',
						'text-align': 'center',
					}
				},
				'.editor-color-picker': {
					'position': 'absolute',
					'line-height': '90%',
					'[data-command][data-color]': {
						display: 'inline-block',
						width: '20px',
						height: '20px',
						border: '1px solid #000',
						cursor: 'pointer'
					}
				}
			}
		},
		// link
		'[data-g][data-toolkit="link"]': Object.assign({
				'min-width': '200px',
				'min-height': '150px',
				'padding': '10px',
				'border': '1px solid #E2E3E3',
				'border-radius': '5px',
				'box-shadow': '2px 2px 2px #d6d6d6',
				'color': '#232731',
				'font-size': '14px',
				'background-color': 'rgba(255, 255, 255, 0.9)',
				'.grm-g-header': {
					'height': '23px'
				},
				'.grm-g-footer': {
					'height': '23px'
				},
				'.grm-g-title': {
					// 'min-height': '10px'
				},
				'.grm-g-body': {
					'position': 'relative',
					'overflow': 'hidden',
					'padding': '10px 0',
					'height': 'calc(100% - 60px)',
					'.grm-g-content': {
						'width': '100%',
						'height': 'calc(100% - 2px)',
						'border': '1px solid #E0E0E0',
						'text-align': 'center',
					},
					'.grm-g-content-cover': {
						'display': 'none',
						'position': 'absolute',
						'left': '0px',
						'top': '0px',
						'width': '100%',
						'height': '100%',
						'background-color': 'rgba(255, 255, 255, 0.3)',
					}
				},
				'&:not([data-grm-play-state="playing"])': {
					'&:hover .grm-g-content-cover': {
						'display': 'block'
					}
				},
				// '.grm-g-wrapper': {
				// 	'margin': '10px'
				// }
			}, (function(){
				var css = {
					'.grm-g-service-type': {
						'position': 'relative',
						'padding-left': '25px',
						'font-weight': '700',
						'&:before': {
							'content': '',
							'position': 'absolute',
							'left': '0',
							'top': '0',
							'width': '100%',
    						'height': '100%',
							'background-repeat': 'no-repeat',
						}
					}
				};
				var data = {
					youtube: {
						iconUrl: 'https://m.youtube.com/favicon.ico'
					}
				};
				for(var type in data){
					var info = data[type];
					css['&[data-link-service-type="' + type + '"]'] = {
						'.grm-g-service-type:before': {
							'background-image': 'url("'+info.iconUrl+'")',
							'top': '2px'
						}
					};
				}

				return css;
			}())
		),
		// image
		'[data-g][data-toolkit="image"]': {
			'img': {
				'width': '100%',
				'height': '100%',
			}
		},
		'[data-grm-cvs="drag-box"]': {
			'position': 'absolute',
			'border': '1px solid #0078D7',
			'background-color': 'rgba(106, 169, 232, 0.5)',
			'display': 'none'
		},
		'[data-grm-laserpointer]': {
			'pointer-events': 'none',
			'[data-pointer-name]': {
				'position': 'absolute',
				'left': '60%',
				'top': '60%',
				'padding': '2px 4px',
				'word-break': 'keep-all',
				'color': '#fff',
				'font-size': '1px',
				'opacity': '.7'
			}
		},
		'.grm-cvs-btn-play': {
			'display': 'block',
			'position': 'relative',
			'top': 'calc(50% - 30px)',
			'z-index': 1,
			'cursor': 'pointer',
			'width': 0,
			'height': 0,
			'border-top': '30px solid transparent',
			'border-bottom': '30px solid transparent',
			'border-left': '40px solid #2c3e50',
			'margin': 'auto auto',
			'transition': 'all 0.3s',
			'&:hover': {
				'border-left-color': '#fff'
			}
			// '&:before': {
			// 	content: '',
			// 	position: 'absolute',
			// 	top: '-75px',
			// 	left: '-115px',
			// 	bottom: '-75px',
			// 	right: '-35px',
			// 	'border-radius': '50%',
			// 	border: '10px solid #2c3e50',
			// 	'z-index': '2',
			// 	transition: 'all 0.3s',
			// },
			// '&:after': {
			// 	content: '',
			// 	opacity: 0,
			// 	transition: 'opacity 0.6s',
			// }
		},
		'.grm-cvs-drag-copy-el': {
			'position': 'relative',
			'left': '0px',
			'top': '0px',
			// 'width': '50px',
			// 'height': '50px',
			'display': 'inline-block',
    		'padding': '5px 10px 8px 8px',
			'border': '3px solid #0cf',
			'color': '#0cf',
			'font-size': '22px',
			'font-weight': '900',
			'background-color': 'rgba(255, 255, 255, 0.7)',
			// 'pointer-events': 'none',
			// '&:before, &:after': {
			// 	'content': '',
			// 	'position': 'absolute',
			// 	'background-color': '#0cf',
			// },
			// '&:before': {
			// 	'left': '12.5px',
			// 	'top': 'calc(50% - 1.5px)',
			// 	'width': '25px',
			// 	'height': '3px'
			// },
			// '&:after': {
			// 	'top': '12.5px',
			// 	'left': 'calc(50% - 1.5px)',
			// 	'height': '25px',
			// 	'width': '3px'
			// }
		},
	}

	// icon
	Object.assign(GrmCvsCssObj, {
		'[data-g-icon]': {
			'position': 'relative',
			'z-index': 1,
			'overflow': 'hidden',
			'list-style': 'none',
			'padding': '0',
			'margin': '0 0 0.25em',

			'&:before, &:after, a:before, a:after': {
				'content': '',
				position: 'absolute',
				top: '50%',
				left: '0',
			},
			
			'a': {
				'&:before, &:after': {
					margin: '-8px 0 0',
    				background: '#c55500',
				},
			},
		},
		'[data-g-icon="enlarge"]': {
			'&:before': {
				width: '16px',
				height: '14px',
				'margin-top': '-7px',
			},
			'&:after': {
				left: '1px',
				width: '7px',
				height: '6px',
				'margin-top': '-6px',
				background: '#fff',
			},
		}
	});

	{
		if(!HTMLElement.prototype._trigger){
			[Window, HTMLElement].forEach(function(H){
				H.prototype._trigger = function(type, data){
					var event = document.createEvent('Event');
					event.initEvent(type, true, true);
					if(data) event.data = data;
					this.dispatchEvent(event);
					return this;
				}
				H.prototype._on = function(type, func, opt){
					type.split(' ').forEach((function(t){
						t = t.trim();
						if(!t) return;
						if(opt === undefined){
							this.addEventListener(t, func);
						}else{
							this.addEventListener(t, func, opt);
						}
					}).bind(this));
					return this;
				}
				H.prototype._off = function(type, func, opt){
					type.split(' ').forEach((function(t){
						t = t.trim();
						if(!t) return;
						if(opt === undefined){
							this.removeEventListener(t, func);
						}else{
							this.removeEventListener(t, func, opt);
						}
					}).bind(this));
					return this;
				}
			});
		}
		if (!Element.prototype.matches){
			Element.prototype.matches =
			Element.prototype.msMatchesSelector ||
			Element.prototype.webkitMatchesSelector;
		}

		if (!Element.prototype.closest){
			Element.prototype.closest = function(s) {
				var el = this;
				if (!document.documentElement.contains(el))
					return null;
				do {
					if (el.matches(s))
						return el;
					el = el.parentElement || el.parentNode;
				} while (el);
				return null;
			};
		}

		if (window.NodeList && !NodeList.prototype.forEach) {
			NodeList.prototype.forEach = function(callback, thisArg) {
				thisArg = thisArg || window;
				for (var i = 0; i < this.length; i++) {
					callback.call(thisArg, this[i], i, this);
				}
			};
		}
	}

	// noconfilct
	var __old = window.GooroomeeCanvas;
	window.GooroomeeCanvas = GooroomeeCanvas;
	GooroomeeCanvas.noConfilict = function(){
		window.GooroomeeCanvas = __old;
		return GooroomeeCanvas;
	}

	/**
	 * Detect Element Resize
	 *
	 * https://github.com/sdecima/javascript-detect-element-resize
	 * Sebastian Decima
	 *
	 * version: 0.5.3
	 **/

	var addResizeListener, removeResizeListener;
	(function () {
		var attachEvent = document.attachEvent,
			stylesCreated = false;

		function resetTriggers(element){
			var triggers = element.__resizeTriggers__,
				expand = triggers.firstElementChild,
				contract = triggers.lastElementChild,
				expandChild = expand.firstElementChild;
			contract.scrollLeft = contract.scrollWidth;
			contract.scrollTop = contract.scrollHeight;
			expandChild.style.width = expand.offsetWidth + 1 + 'px';
			expandChild.style.height = expand.offsetHeight + 1 + 'px';
			expand.scrollLeft = expand.scrollWidth;
			expand.scrollTop = expand.scrollHeight;
		};

		function checkTriggers(element){
			return element.offsetWidth != element.__resizeLast__.width ||
				element.offsetHeight != element.__resizeLast__.height;
		}

		function scrollListener(e){
			var element = this;
//			var lastST = element.getAttribute('lastST') || -1;
//			var lastSL = element.getAttribute('lastSL') || -1;
//
//			if(element.scrollTop == lastST && element.scrollLeft == lastSL){
//				return;
//			}else{
//				element.setAttribute('lastST', element.scrollTop);
//				element.setAttribute('lastSL', element.scrollLeft);
//			}

			resetTriggers(this);
			if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
			this.__resizeRAF__ = requestFrame(function(){
				if (checkTriggers(element)) {
					element.__resizeLast__.width = element.offsetWidth;
					element.__resizeLast__.height = element.offsetHeight;
					element.__resizeListeners__.forEach(function(fn){
						fn.call(element, e);
					});
				}
			});
		};

		if (!attachEvent) {
			var requestFrame = (function(){
				var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
					function(fn){ return window.setTimeout(fn, 20); };
				return function(fn){ return raf(fn); };
			})();

			var cancelFrame = (function(){
				var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame ||
					window.clearTimeout;
				return function(id){ return cancel(id); };
			})();

			/* Detect CSS Animations support to detect element display/re-attach */
			var animation = false,
				animationstring = 'animation',
				keyframeprefix = '',
				animationstartevent = 'animationstart',
				domPrefixes = 'Webkit Moz O ms'.split(' '),
				startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
				pfx  = '';
			{
				var elm = document.createElement('fakeelement');
				if( elm.style.animationName !== undefined ) { animation = true; }

				if( animation === false ) {
					for( var i = 0; i < domPrefixes.length; i++ ) {
						if( elm.style[ domPrefixes[i] + 'AnimationName' ] !== undefined ) {
							pfx = domPrefixes[ i ];
							animationstring = pfx + 'Animation';
							keyframeprefix = '-' + pfx.toLowerCase() + '-';
							animationstartevent = startEvents[ i ];
							animation = true;
							break;
						}
					}
				}
			}

			var animationName = 'resizeanim';
			var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
			var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
		}

		function createStyles() {
			if (!stylesCreated) {
				//opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
				var css = (animationKeyframes ? animationKeyframes : '') +
					'.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' +
					'.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
					head = document.head || document.getElementsByTagName('head')[0],
					style = document.createElement('style');

				style.type = 'text/css';
				if (style.styleSheet) {
					style.styleSheet.cssText = css;
				} else {
					style.appendChild(document.createTextNode(css));
				}

				head.appendChild(style);
				stylesCreated = true;
			}
		}

		addResizeListener = function(element, fn){
			if (attachEvent) element.attachEvent('onresize', fn);
			else {
				if (!element.__resizeTriggers__) {
					if (getComputedStyle(element).position == 'static') element.style.position = 'relative';
					createStyles();
					element.__resizeLast__ = {};
					element.__resizeListeners__ = [];
					(element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
					element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' +
						'<div class="contract-trigger"></div>';
					element.appendChild(element.__resizeTriggers__);
					resetTriggers(element);
					element.addEventListener('scroll', scrollListener, true);

					/* Listen for a css animation to detect element display/re-attach */
					animationstartevent && element.__resizeTriggers__.addEventListener(animationstartevent, function(e) {
						if(e.animationName == animationName)
							resetTriggers(element);
					});
				}
				element.__resizeListeners__.push(fn);
			}
		};

		removeResizeListener = function(element, fn){
			if (attachEvent) element.detachEvent('onresize', fn);
			else {
				element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
				if (!element.__resizeListeners__.length) {
					element.removeEventListener('scroll', scrollListener);
					element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
				}
			}
		}
	})();
	// end of Detect Element Resize

}());